import { FC, memo } from "react";
import { SvgIconConstituentValues } from "../index";

//BASE ICONS
/*
    Feather is a collection of simply beautiful open source icons designed by Cole Bemis (@colebemis).
  Each icon is designed on a 24x24 grid with an emphasis on simplicity, consistency and readability.
  Colors can also be changed via symbol overrides. All strokes in these icons have been converted to
  single vectors so color overrides are respected within variants.
*/

export const Layers2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M2 14.5L12 19.5L22 14.5M12 4.5L2 9.5L12 14.5L22 9.5L12 4.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const Layers3: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M2 17L12 22L22 17M2 12L12 17L22 12M12 2L2 7L12 12L22 7L12 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const activity: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M22 12H18L15 21L9 3L6 12H2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const airplay: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5 17H4C3.46957 17 2.96086 16.7893 2.58579 16.4142C2.21071 16.0391 2 15.5304 2 15V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V15C22 15.5304 21.7893 16.0391 21.4142 16.4142C21.0391 16.7893 20.5304 17 20 17H19M12 15L17 21H7L12 15Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const alertCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const alertOctagon: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 8V12M12 16H12.01M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const alertTriangle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M11.9998 7.99999V12M11.9998 16H12.0098M10.2898 2.85999L1.81978 17C1.64514 17.3024 1.55274 17.6453 1.55177 17.9945C1.55079 18.3437 1.64127 18.6871 1.8142 18.9905C1.98714 19.2939 2.2365 19.5467 2.53748 19.7238C2.83847 19.9009 3.18058 19.9962 3.52978 20H20.4698C20.819 19.9962 21.1611 19.9009 21.4621 19.7238C21.7631 19.5467 22.0124 19.2939 22.1854 18.9905C22.3583 18.6871 22.4488 18.3437 22.4478 17.9945C22.4468 17.6453 22.3544 17.3024 22.1798 17L13.7098 2.85999C13.5315 2.5661 13.2805 2.32311 12.981 2.15447C12.6814 1.98584 12.3435 1.89725 11.9998 1.89725C11.656 1.89725 11.3181 1.98584 11.0186 2.15447C10.7191 2.32311 10.468 2.5661 10.2898 2.85999Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const alignCenter: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M18 10H6M21 6H3M21 14H3M18 18H6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const alignJustify: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M21 10H3M21 6H3M21 14H3M21 18H3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const alignLeft: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M17 10H3M21 6H3M21 14H3M17 18H3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const alignRight: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M21 10H7M21 6H3M21 14H3M21 18H7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const anchor: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 8C13.6569 8 15 6.65685 15 5C15 3.34315 13.6569 2 12 2C10.3431 2 9 3.34315 9 5C9 6.65685 10.3431 8 12 8ZM12 8V22M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12H5M12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12H19"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const aperture: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M14.31 8L20.05 17.94M9.69 8H21.17M7.38 12L13.12 2.06M9.69 16L3.95 6.06M14.31 16H2.83M16.62 12L10.88 21.94M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const archive: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M21 8V21H3V8M10 12H14M1 3H23V8H1V3Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const arrowDownCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 12L12 16M12 16L16 12M12 16V8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const arrowDownLeft: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M17 7L7 17M7 17H17M7 17V7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const arrowDownRight: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M7 7L17 17M17 17V7M17 17H7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const arrowDown: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 5V19M12 19L19 12M12 19L5 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const arrowLeftCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 8L8 12M8 12L12 16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const arrowLeft: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M19 12H5M5 12L12 19M5 12L12 5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const arrowRightCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 16L16 12M16 12L12 8M16 12H8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const arrowRight: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M5 12H19M19 12L12 5M19 12L12 19" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const arrowUpCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 12L12 8M12 8L8 12M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const arrowUpLeft: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M17 17L7 7M7 7V17M7 7H17" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const arrowUpRight: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M7 17L17 7M17 7H7M17 7V17" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const arrowUp: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 19V5M12 5L5 12M12 5L19 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const atSign: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 8V13C16 13.7956 16.3161 14.5587 16.8787 15.1213C17.4413 15.6839 18.2044 16 19 16C19.7957 16 20.5587 15.6839 21.1213 15.1213C21.6839 14.5587 22 13.7956 22 13V12C21.9999 9.74303 21.2362 7.55247 19.8333 5.78453C18.4303 4.01658 16.4706 2.77522 14.2726 2.26229C12.0747 1.74937 9.76794 1.99504 7.72736 2.95936C5.68677 3.92369 4.03241 5.54995 3.03327 7.57372C2.03413 9.59749 1.74898 11.8997 2.22418 14.1061C2.69938 16.3125 3.90699 18.2932 5.65064 19.7263C7.39429 21.1593 9.57144 21.9603 11.8281 21.9991C14.0847 22.038 16.2881 21.3122 18.08 19.94M16 12C16 14.2091 14.2092 16 12 16C9.79087 16 8.00001 14.2091 8.00001 12C8.00001 9.79086 9.79087 8 12 8C14.2092 8 16 9.79086 16 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const award: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88M19 8C19 11.866 15.866 15 12 15C8.13401 15 5 11.866 5 8C5 4.13401 8.13401 1 12 1C15.866 1 19 4.13401 19 8Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const barChart2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M18 20V10M12 20V4M6 20V14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const barChart: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 20V10M18 20V4M6 20V16" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const batteryCharging: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5 18H3C2.46957 18 1.96086 17.7893 1.58579 17.4142C1.21071 17.0391 1 16.5304 1 16V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H6.19M15 6H17C17.5304 6 18.0391 6.21071 18.4142 6.58579C18.7893 6.96086 19 7.46957 19 8V16C19 16.5304 18.7893 17.0391 18.4142 17.4142C18.0391 17.7893 17.5304 18 17 18H13.81M23 13V11M11 6L7 12H13L9 18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const battery: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M23 13V11M3 6H17C18.1046 6 19 6.89543 19 8V16C19 17.1046 18.1046 18 17 18H3C1.89543 18 1 17.1046 1 16V8C1 6.89543 1.89543 6 3 6Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const bellOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M13.73 21C13.5542 21.3031 13.3018 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21M18.63 13C18.1851 11.3714 17.973 9.68804 18 8C18.0016 6.91306 17.7079 5.84611 17.1503 4.91309C16.5927 3.98008 15.7922 3.21606 14.8341 2.70264C13.8761 2.18922 12.7966 1.94569 11.7109 1.99807C10.6252 2.05044 9.57417 2.39675 8.67 3M6.26 6.26C6.08627 6.82361 5.99861 7.41022 6 8C6 15 3 17 3 17H17M1 1L23 23"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const bell: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M13.73 21C13.5542 21.3031 13.3018 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const bluetooth: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M6.5 6.5L17.5 17.5L12 23V1L17.5 6.5L6.5 17.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const bold: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M6 12H14C15.0609 12 16.0783 11.5786 16.8284 10.8284C17.5786 10.0783 18 9.06087 18 8C18 6.93913 17.5786 5.92172 16.8284 5.17157C16.0783 4.42143 15.0609 4 14 4H6V12ZM6 12H15C16.0609 12 17.0783 12.4214 17.8284 13.1716C18.5786 13.9217 19 14.9391 19 16C19 17.0609 18.5786 18.0783 17.8284 18.8284C17.0783 19.5786 16.0609 20 15 20H6V12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const bookOpen: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 7C12 5.93913 11.5786 4.92172 10.8284 4.17157C10.0783 3.42143 9.06087 3 8 3H2V18H9C9.79565 18 10.5587 18.3161 11.1213 18.8787C11.6839 19.4413 12 20.2044 12 21M12 7V21M12 7C12 5.93913 12.4214 4.92172 13.1716 4.17157C13.9217 3.42143 14.9391 3 16 3H22V18H15C14.2044 18 13.4413 18.3161 12.8787 18.8787C12.3161 19.4413 12 20.2044 12 21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const book: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20M4 19.5C4 20.163 4.26339 20.7989 4.73223 21.2678C5.20107 21.7366 5.83696 22 6.5 22H20V2H6.5C5.83696 2 5.20107 2.26339 4.73223 2.73223C4.26339 3.20107 4 3.83696 4 4.5V19.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const bookmark: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const box: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M3.27 6.96L12 12.01L20.73 6.96M12 22.08V12M21 16V8C20.9996 7.64928 20.9071 7.30481 20.7315 7.00116C20.556 6.69752 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69752 3.26846 7.00116C3.09294 7.30481 3.00036 7.64928 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const briefcase: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21M4 7H20C21.1046 7 22 7.89543 22 9V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V9C2 7.89543 2.89543 7 4 7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const calendar: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 2V6M8 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cameraOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M1 1L23 23M9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V17.34M15.28 15.28C14.9481 15.765 14.5134 16.171 14.0068 16.469C13.5002 16.7669 12.9342 16.9496 12.3489 17.004C11.7637 17.0584 11.1737 16.9831 10.6209 16.7836C10.0681 16.5841 9.56601 16.2652 9.15042 15.8496C8.73483 15.434 8.41593 14.9319 8.2164 14.3791C8.01688 13.8263 7.94163 13.2363 7.99601 12.6511C8.05039 12.0658 8.23306 11.4998 8.53103 10.9932C8.829 10.4866 9.23495 10.0519 9.72 9.72M21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H6L21 21Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const camera: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cast: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M2 16.1C2.96089 16.296 3.84294 16.7702 4.53638 17.4636C5.22982 18.1571 5.70403 19.0391 5.9 20M2 12.05C4.03079 12.2759 5.92428 13.186 7.36911 14.6309C8.81395 16.0757 9.72414 17.9692 9.95 20M2 8V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H14M2 20H2.01"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const checkCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18456 2.99721 7.13633 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24015C11.8996 1.76491 14.1003 1.98234 16.07 2.86M22 4L12 14.01L9.00001 11.01"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const checkSquare: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 11L12 14L22 4M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const check: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M20 6L9 17L4 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const chevronDown: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M6 9L12 15L18 9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const chevronLeft: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M15 18L9 12L15 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const chevronRight: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M9 18L15 12L9 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const chevronUp: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M18 15L12 9L6 15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const chevronsDown: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M7 13L12 18L17 13M7 6L12 11L17 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const chevronsLeft: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M11 17L6 12L11 7M18 17L13 12L18 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const chevronsRight: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M13 17L18 12L13 7M6 17L11 12L6 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const chevronsUp: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M17 11L12 6L7 11M17 18L12 13L7 18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const chrome: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM12 8H21.17M3.95 6.06L8.54 14M10.88 21.94L15.46 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const circle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const clipboard: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8M9 2H15C15.5523 2 16 2.44772 16 3V5C16 5.55228 15.5523 6 15 6H9C8.44772 6 8 5.55228 8 5V3C8 2.44772 8.44772 2 9 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const clock: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cloudDrizzle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6499)">
      <path
        d="M8.00003 19V21M8.00003 13V15M16 19V21M16 13V15M12 21V23M12 15V17M20 16.58C21.0513 16.1196 21.9121 15.3116 22.4381 14.2915C22.9641 13.2715 23.1232 12.1016 22.8886 10.9782C22.6541 9.85476 22.0402 8.84621 21.1501 8.12183C20.2599 7.39746 19.1477 7.00135 18 7H16.74C16.4231 5.77252 15.8189 4.63795 14.9773 3.6898C14.1358 2.74165 13.081 2.00708 11.8998 1.54662C10.7186 1.08617 9.44494 0.913016 8.18372 1.04144C6.92249 1.16987 5.70984 1.5962 4.64573 2.28528C3.58161 2.97437 2.6965 3.90648 2.06334 5.0048C1.43018 6.10311 1.06711 7.33617 1.00404 8.60235C0.940984 9.86853 1.17974 11.1316 1.70064 12.2874C2.22153 13.4431 3.00965 14.4586 4.00003 15.25"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6499">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const cloudLightning: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6520)">
      <path
        d="M18.9999 16.9C20.2151 16.6533 21.2952 15.9638 22.0306 14.9655C22.766 13.9671 23.1043 12.7312 22.9796 11.4975C22.855 10.2638 22.2765 9.12046 21.3563 8.28937C20.4361 7.45828 19.2399 6.99875 17.9999 7H16.7399C16.4086 5.71732 15.764 4.53699 14.8638 3.56498C13.9637 2.59298 12.8363 1.85973 11.5828 1.43106C10.3292 1.00239 8.98891 0.89173 7.68207 1.10901C6.37523 1.32628 5.1428 1.8647 4.09544 2.67591C3.04808 3.48712 2.21856 4.54573 1.68137 5.75671C1.14418 6.96768 0.916124 8.29311 1.01769 9.61399C1.11925 10.9349 1.54725 12.2098 2.26326 13.3245C2.97926 14.4391 3.96087 15.3584 5.11993 16M12.9999 11L8.99993 17H14.9999L10.9999 23"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6520">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const cloudOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6739)">
      <path
        d="M22.61 16.95C22.9322 16.1893 23.0609 15.3606 22.9845 14.5381C22.9082 13.7155 22.6293 12.9246 22.1726 12.2362C21.716 11.5478 21.0959 10.9832 20.3677 10.593C19.6396 10.2027 18.8261 9.99902 18 10H16.74C16.3318 8.39249 15.4341 6.95158 14.171 5.87666C12.908 4.80173 11.3421 4.14593 9.68999 4M4.99999 5C3.43807 5.86364 2.2098 7.22478 1.51058 8.86691C0.811359 10.509 0.681344 12.3378 1.14122 14.0623C1.60109 15.7869 2.62444 17.3081 4.04847 18.384C5.47251 19.4599 7.21543 20.0288 8.99999 20H18C18.5798 19.9993 19.155 19.8978 19.7 19.7M0.999991 1L23 23"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6739">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const cloudRain: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6712)">
      <path
        d="M16 13V21M8.00003 13V21M12 15V23M20 16.58C21.0513 16.1196 21.9121 15.3116 22.4381 14.2915C22.9641 13.2715 23.1232 12.1016 22.8886 10.9782C22.6541 9.85476 22.0402 8.84622 21.1501 8.12184C20.2599 7.39746 19.1477 7.00135 18 7H16.74C16.4231 5.77252 15.8189 4.63795 14.9773 3.6898C14.1358 2.74166 13.081 2.00708 11.8998 1.54662C10.7186 1.08617 9.44494 0.91302 8.18372 1.04145C6.92249 1.16987 5.70984 1.5962 4.64573 2.28529C3.58161 2.97437 2.6965 3.90649 2.06334 5.0048C1.43018 6.10311 1.06711 7.33618 1.00404 8.60235C0.940984 9.86853 1.17974 11.1316 1.70064 12.2874C2.22153 13.4431 3.00965 14.4586 4.00003 15.25"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6712">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const cloudSnow: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6681)">
      <path
        d="M20 17.58C21.0513 17.1196 21.9121 16.3116 22.4381 15.2915C22.9641 14.2715 23.1232 13.1016 22.8886 11.9782C22.6541 10.8548 22.0402 9.84622 21.1501 9.12184C20.2599 8.39746 19.1477 8.00135 18 8H16.74C16.4231 6.77252 15.8189 5.63795 14.9773 4.6898C14.1358 3.74165 13.081 3.00708 11.8998 2.54662C10.7186 2.08617 9.44494 1.91302 8.18372 2.04145C6.92249 2.16987 5.70984 2.5962 4.64573 3.28529C3.58161 3.97437 2.6965 4.90649 2.06334 6.0048C1.43018 7.10311 1.06711 8.33618 1.00404 9.60235C0.940984 10.8685 1.17974 12.1316 1.70064 13.2874C2.22153 14.4431 3.00965 15.4586 4.00003 16.25M8.00003 16H8.01003M8.00003 20H8.01003M12 18H12.01M12 22H12.01M16 16H16.01M16 20H16.01"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6681">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const cloud: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6639)">
      <path
        d="M18.0001 10H16.7401C16.366 8.551 15.5929 7.23599 14.5088 6.2044C13.4246 5.1728 12.0728 4.46599 10.607 4.16428C9.14124 3.86256 7.6202 3.97804 6.21676 4.49759C4.81332 5.01714 3.58375 5.91993 2.66776 7.10338C1.75177 8.28683 1.1861 9.70348 1.03502 11.1924C0.883935 12.6812 1.1535 14.1826 1.81309 15.526C2.47267 16.8693 3.49583 18.0007 4.76629 18.7916C6.03676 19.5824 7.50359 20.0011 9.00011 20H18.0001C19.3262 20 20.598 19.4732 21.5356 18.5355C22.4733 17.5979 23.0001 16.3261 23.0001 15C23.0001 13.6739 22.4733 12.4021 21.5356 11.4645C20.598 10.5268 19.3262 10 18.0001 10Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6639">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const code: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M16 18L22 12L16 6M8 6L2 12L8 18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const codepen: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 2L22 8.5M12 2L2 8.5M12 2V8.5M22 8.5V15.5M22 8.5L12 15.5M22 15.5L12 22M22 15.5L12 8.5M12 22L2 15.5M12 22V15.5M2 15.5V8.5M2 15.5L12 8.5M2 8.5L12 15.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const codesandbox: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M7.5 4.21L12 6.81L16.5 4.21M7.5 19.79V14.6L3 12M21 12L16.5 14.6V19.79M3.27 6.96L12 12.01L20.73 6.96M12 22.08V12M21 16V8C20.9996 7.64928 20.9071 7.30481 20.7315 7.00116C20.556 6.69752 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69752 3.26846 7.00116C3.09294 7.30481 3.00036 7.64928 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const coffee: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M18 8H19C20.0609 8 21.0783 8.42143 21.8284 9.17157C22.5786 9.92172 23 10.9391 23 12C23 13.0609 22.5786 14.0783 21.8284 14.8284C21.0783 15.5786 20.0609 16 19 16H18M18 8H2V17C2 18.0609 2.42143 19.0783 3.17157 19.8284C3.92172 20.5786 4.93913 21 6 21H14C15.0609 21 16.0783 20.5786 16.8284 19.8284C17.5786 19.0783 18 18.0609 18 17V8ZM6 1V4M10 1V4M14 1V4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const coinStack: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M14.1755 4.22225C14.1766 2.99445 11.6731 2 8.58832 2C5.50357 2 3.00224 2.99557 3 4.22225M3 4.22225C3 5.45004 5.50133 6.44449 8.58832 6.44449C11.6753 6.44449 14.1766 5.45004 14.1766 4.22225L14.1766 12.8445M3 4.22225V17.5556C3.00112 18.7834 5.50245 19.7779 8.58832 19.7779C10.0849 19.7779 11.4361 19.5412 12.4387 19.1601M3.00112 8.66672C3.00112 9.89451 5.50245 10.889 8.58944 10.889C11.6764 10.889 14.1778 9.89451 14.1778 8.66672M12.5057 14.6946C11.4976 15.0891 10.115 15.3335 8.58832 15.3335C5.50245 15.3335 3.00112 14.3391 3.00112 13.1113M20.5272 13.4646C22.4909 15.4169 22.4909 18.5836 20.5272 20.5358C18.5635 22.4881 15.3781 22.4881 13.4144 20.5358C11.4507 18.5836 11.4507 15.4169 13.4144 13.4646C15.3781 11.5124 18.5635 11.5124 20.5272 13.4646Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const coins: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9.42202 4.15802C12.2986 1.2801 16.964 1.28122 19.8417 4.15802C22.7194 7.03483 22.7194 11.7006 19.8417 14.5785M16.7374 14.6308C16.7374 18.7007 13.4383 22 9.36868 22C5.29907 22 2 18.7007 2 14.6308C2 10.5608 5.29907 7.26151 9.36868 7.26151C13.4383 7.26151 16.7374 10.5608 16.7374 14.6308Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const columns: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 3V21M12 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H12V3ZM12 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H12V3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const command: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M18 3C17.2044 3 16.4413 3.31607 15.8787 3.87868C15.3161 4.44129 15 5.20435 15 6V18C15 18.7956 15.3161 19.5587 15.8787 20.1213C16.4413 20.6839 17.2044 21 18 21C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15H6C5.20435 15 4.44129 15.3161 3.87868 15.8787C3.31607 16.4413 3 17.2044 3 18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21C6.79565 21 7.55871 20.6839 8.12132 20.1213C8.68393 19.5587 9 18.7956 9 18V6C9 5.20435 8.68393 4.44129 8.12132 3.87868C7.55871 3.31607 6.79565 3 6 3C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6C3 6.79565 3.31607 7.55871 3.87868 8.12132C4.44129 8.68393 5.20435 9 6 9H18C18.7956 9 19.5587 8.68393 20.1213 8.12132C20.6839 7.55871 21 6.79565 21 6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const compass: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.24 7.76L14.12 14.12L7.76 16.24L9.88 9.88L16.24 7.76Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const copy: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5M11 9H20C21.1046 9 22 9.89543 22 11V20C22 21.1046 21.1046 22 20 22H11C9.89543 22 9 21.1046 9 20V11C9 9.89543 9.89543 9 11 9Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cornerDownLeft: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 10L4 15M4 15L9 20M4 15H16C17.0609 15 18.0783 14.5786 18.8284 13.8284C19.5786 13.0783 20 12.0609 20 11V4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cornerDownRight: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15 10L20 15M20 15L15 20M20 15H8C6.93913 15 5.92172 14.5786 5.17157 13.8284C4.42143 13.0783 4 12.0609 4 11V4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cornerLeftDown: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M14 15L9 20M9 20L4 15M9 20V8C9 6.93913 9.42143 5.92172 10.1716 5.17157C10.9217 4.42143 11.9391 4 13 4H20"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cornerLeftUp: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M14 9L9 4M9 4L4 9M9 4V16C9 17.0609 9.42143 18.0783 10.1716 18.8284C10.9217 19.5786 11.9391 20 13 20H20"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cornerRightDown: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10 15L15 20M15 20L20 15M15 20V8C15 6.93913 14.5786 5.92172 13.8284 5.17157C13.0783 4.42143 12.0609 4 11 4H4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cornerRightUp: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10 9L15 4M15 4L20 9M15 4V16C15 17.0609 14.5786 18.0783 13.8284 18.8284C13.0783 19.5786 12.0609 20 11 20H4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cornerUpLeft: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 14L4 9M4 9L9 4M4 9H16C17.0609 9 18.0783 9.42143 18.8284 10.1716C19.5786 10.9217 20 11.9391 20 13V20"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cornerUpRight: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15 14L20 9M20 9L15 4M20 9H8C6.93913 9 5.92172 9.42143 5.17157 10.1716C4.42143 10.9217 4 11.9391 4 13V20"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const cpu: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 1V4M15 1V4M9 20V23M15 20V23M20 9H23M20 14H23M1 9H4M1 14H4M6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4ZM9 9H15V15H9V9Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const creditCard: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M1 10H23M3 4H21C22.1046 4 23 4.89543 23 6V18C23 19.1046 22.1046 20 21 20H3C1.89543 20 1 19.1046 1 18V6C1 4.89543 1.89543 4 3 4Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const crop: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M6.13 1L6 16C6 16.5304 6.21071 17.0391 6.58579 17.4142C6.96086 17.7893 7.46957 18 8 18H23M1 6.13L16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8V23"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const crosshair: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12H18M12 22C6.47715 22 2 17.5228 2 12M12 22V18M2 12C2 6.47715 6.47715 2 12 2M2 12H6M12 2V6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const database: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.66 17 22 12 22C7 22 3 20.66 3 19V5M21 12C21 13.66 17 15 12 15C7 15 3 13.66 3 12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const remove: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M18 9L12 15M12 9L18 15M21 4H8L1 12L8 20H21C21.5304 20 22.0391 19.7893 22.4142 19.4142C22.7893 19.0391 23 18.5304 23 18V6C23 5.46957 22.7893 4.96086 22.4142 4.58579C22.0391 4.21071 21.5304 4 21 4Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const disc: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const divideCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const divideSquare: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 12H16M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const divide: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5 12H19M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6ZM14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const dollarSign: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const downloadCloud: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6716)">
      <path
        d="M8.00018 17L12.0002 21M12.0002 21L16.0002 17M12.0002 21V12M20.8802 18.09C21.7496 17.4786 22.4015 16.6061 22.7415 15.5991C23.0814 14.5921 23.0916 13.503 22.7706 12.4898C22.4496 11.4766 21.814 10.5921 20.9562 9.96456C20.0985 9.33703 19.063 8.99916 18.0002 8.99999H16.7402C16.4394 7.82787 15.8767 6.73924 15.0943 5.81607C14.3119 4.89291 13.3303 4.15925 12.2234 3.67035C11.1164 3.18144 9.91302 2.95002 8.7037 2.99351C7.49439 3.037 6.31069 3.35426 5.24173 3.92142C4.17277 4.48858 3.2464 5.29084 2.53236 6.26782C1.81833 7.2448 1.33523 8.37104 1.11944 9.56174C0.903647 10.7524 0.960787 11.9766 1.28656 13.142C1.61233 14.3074 2.19824 15.3838 3.00018 16.29"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6716">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const download: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const dribbble: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8.56 2.75C12.93 8.78 14.58 12.17 16.59 20.47M19.13 5.09C15.41 9.44 10.19 10.75 2.25 10.94M21.75 12.84C18.25 11.91 15.12 12.02 12.81 12.84C10.23 13.76 7.8 15.7 5.37 19.16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const droplet: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M11.9999 2.69L17.6599 8.35C18.7792 9.46861 19.5417 10.8941 19.8508 12.4461C20.1599 13.998 20.0018 15.6069 19.3964 17.069C18.7911 18.5311 17.7657 19.7808 16.45 20.6601C15.1343 21.5394 13.5874 22.0087 12.0049 22.0087C10.4224 22.0087 8.87549 21.5394 7.55978 20.6601C6.24407 19.7808 5.2187 18.5311 4.61335 17.069C4.008 15.6069 3.84988 13.998 4.15899 12.4461C4.46809 10.8941 5.23054 9.46861 6.34989 8.35L11.9999 2.69Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const edit2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const edit3: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 20H21M16.5 3.50001C16.8978 3.10219 17.4374 2.87869 18 2.87869C18.2786 2.87869 18.5544 2.93356 18.8118 3.04017C19.0692 3.14677 19.303 3.30303 19.5 3.50001C19.697 3.697 19.8532 3.93085 19.9598 4.18822C20.0665 4.44559 20.1213 4.72144 20.1213 5.00001C20.1213 5.27859 20.0665 5.55444 19.9598 5.81181C19.8532 6.06918 19.697 6.30303 19.5 6.50001L7 19L3 20L4 16L16.5 3.50001Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const edit: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M11 4.00001H4C3.46957 4.00001 2.96086 4.21073 2.58579 4.5858C2.21071 4.96087 2 5.46958 2 6.00001V20C2 20.5304 2.21071 21.0392 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0392 20 20.5304 20 20V13M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const externalLink: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11M15 3H21M21 3V9M21 3L10 14"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const eyeOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const eye: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const facebook: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const fastForward: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M13 19L22 12L13 5V19Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 19L11 12L2 5V19Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const feather: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 8.00001L2 22M17.5 15H9M20.24 12.24C21.3658 11.1142 21.9983 9.58719 21.9983 7.99501C21.9983 6.40282 21.3658 4.87585 20.24 3.75001C19.1142 2.62416 17.5872 1.99167 15.995 1.99167C14.4028 1.99167 12.8758 2.62416 11.75 3.75001L5 10.5V19H13.5L20.24 12.24Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const figma: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 2H8.5C7.57174 2 6.6815 2.36875 6.02513 3.02513C5.36875 3.6815 5 4.57174 5 5.5C5 6.42826 5.36875 7.3185 6.02513 7.97487C6.6815 8.63125 7.57174 9 8.5 9M12 2V9M12 2H15.5C15.9596 2 16.4148 2.09053 16.8394 2.26642C17.264 2.44231 17.6499 2.70012 17.9749 3.02513C18.2999 3.35013 18.5577 3.73597 18.7336 4.16061C18.9095 4.58525 19 5.04037 19 5.5C19 5.95963 18.9095 6.41475 18.7336 6.83939C18.5577 7.26403 18.2999 7.64987 17.9749 7.97487C17.6499 8.29988 17.264 8.55769 16.8394 8.73358C16.4148 8.90947 15.9596 9 15.5 9M12 9H8.5M12 9H15.5M12 9V16M8.5 9C7.57174 9 6.6815 9.36875 6.02513 10.0251C5.36875 10.6815 5 11.5717 5 12.5C5 13.4283 5.36875 14.3185 6.02513 14.9749C6.6815 15.6313 7.57174 16 8.5 16M15.5 9C15.0404 9 14.5852 9.09053 14.1606 9.26642C13.736 9.44231 13.3501 9.70012 13.0251 10.0251C12.7001 10.3501 12.4423 10.736 12.2664 11.1606C12.0905 11.5852 12 12.0404 12 12.5C12 12.9596 12.0905 13.4148 12.2664 13.8394C12.4423 14.264 12.7001 14.6499 13.0251 14.9749C13.3501 15.2999 13.736 15.5577 14.1606 15.7336C14.5852 15.9095 15.0404 16 15.5 16C15.9596 16 16.4148 15.9095 16.8394 15.7336C17.264 15.5577 17.6499 15.2999 17.9749 14.9749C18.2999 14.6499 18.5577 14.264 18.7336 13.8394C18.9095 13.4148 19 12.9596 19 12.5C19 12.0404 18.9095 11.5852 18.7336 11.1606C18.5577 10.736 18.2999 10.3501 17.9749 10.0251C17.6499 9.70012 17.264 9.44231 16.8394 9.26642C16.4148 9.09053 15.9596 9 15.5 9ZM8.5 16C7.57174 16 6.6815 16.3687 6.02513 17.0251C5.36875 17.6815 5 18.5717 5 19.5C5 20.4283 5.36875 21.3185 6.02513 21.9749C6.6815 22.6313 7.57174 23 8.5 23C9.42826 23 10.3185 22.6313 10.9749 21.9749C11.6313 21.3185 12 20.4283 12 19.5V16M8.5 16H12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const fileMinus: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8M14 2L20 8M14 2V8H20M9 15H15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const filePlus: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8M14 2L20 8M14 2V8H20M12 18V12M9 15H15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const fileText: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8M14 2L20 8M14 2V8H20M16 13H8M16 17H8M10 9H8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const file: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9M13 2L20 9M13 2V9H20"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const film: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M7 2V22M17 2V22M2 12H22M2 7H7M2 17H7M17 17H22M17 7H22M4.18 2H19.82C21.024 2 22 2.97602 22 4.18V19.82C22 21.024 21.024 22 19.82 22H4.18C2.97602 22 2 21.024 2 19.82V4.18C2 2.97602 2.97602 2 4.18 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const filter: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const FiltersLines: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M6 12H18M3 6H21M9 18H15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const flag: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15ZM4 15V22"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const folderMinus: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 14H15M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const folderPlus: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 11V17M9 14H15M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const folder: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const framer: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5 16H12M5 16V9H19V2H5L19 16H12H5ZM5 16L12 23V16H5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const frown: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M9 9H9.01M15 9H15.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const gift: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M20 12V22H4V12M12 22V7M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7ZM12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7ZM2 7H22V12H2V7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const gitBranch: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M6 3V15M6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21C7.65685 21 9 19.6569 9 18M6 15C7.65685 15 9 16.3431 9 18M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9ZM18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const gitCommit: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M1.0498 12H6.9998M17.0098 12H22.9598M15.9998 12C15.9998 14.2091 14.2089 16 11.9998 16C9.79067 16 7.9998 14.2091 7.9998 12C7.9998 9.79086 9.79067 8 11.9998 8C14.2089 8 15.9998 9.79086 15.9998 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const gitMerge: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18ZM15 18C12.6131 18 10.3239 17.0518 8.63604 15.364C6.94821 13.6761 6 11.3869 6 9M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM6 9V21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const gitPullRequest: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M18 15C16.3431 15 15 16.3431 15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15ZM18 15V8C18 7.46957 17.7893 6.96086 17.4142 6.58579C17.0391 6.21071 16.5304 6 16 6H13M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM6 9V21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const github: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6766)">
      <path
        d="M9 19C4 20.5 4 16.5 2 16M16 22V18.13C16.0375 17.6532 15.9731 17.1738 15.811 16.7238C15.6489 16.2738 15.3929 15.8634 15.06 15.52C18.2 15.17 21.5 13.98 21.5 8.52C21.4997 7.12383 20.9627 5.7812 20 4.77C20.4559 3.54851 20.4236 2.19835 19.91 0.999999C19.91 0.999999 18.73 0.649999 16 2.48C13.708 1.85882 11.292 1.85882 9 2.48C6.27 0.649999 5.09 0.999999 5.09 0.999999C4.57638 2.19835 4.54414 3.54851 5 4.77C4.03013 5.7887 3.49252 7.14346 3.5 8.55C3.5 13.97 6.8 15.16 9.94 15.55C9.611 15.89 9.35726 16.2954 9.19531 16.7399C9.03335 17.1844 8.96681 17.6581 9 18.13V22"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6766">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const gitlab: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6632)">
      <path
        d="M22.6501 14.39L12.0001 22.13L1.35014 14.39C1.20737 14.285 1.10146 14.1375 1.04758 13.9687C0.993694 13.7998 0.994592 13.6183 1.05014 13.45L2.27014 9.66999L4.71014 2.15999C4.73381 2.0988 4.77148 2.044 4.82014 1.99999C4.89938 1.92761 5.00282 1.88748 5.11014 1.88748C5.21746 1.88748 5.32091 1.92761 5.40014 1.99999C5.45153 2.04966 5.48939 2.11161 5.51014 2.17999L7.95014 9.66999H16.0501L18.4901 2.15999C18.5138 2.0988 18.5515 2.044 18.6001 1.99999C18.6794 1.92761 18.7828 1.88748 18.8901 1.88748C18.9975 1.88748 19.1009 1.92761 19.1801 1.99999C19.2315 2.04966 19.2694 2.11161 19.2901 2.17999L21.7301 9.68999L23.0001 13.45C23.0507 13.6235 23.0439 13.8086 22.9809 13.978C22.9178 14.1473 22.8018 14.2918 22.6501 14.39V14.39Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6632">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const globe: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12H2M12 22C6.47715 22 2 17.5228 2 12M12 22C14.5013 19.2616 15.9228 15.708 16 12C15.9228 8.29203 14.5013 4.73835 12 2M12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2M2 12C2 6.47715 6.47715 2 12 2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const grid: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M10 3H3V10H10V3Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 3H14V10H21V3Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 14H14V21H21V14Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 14H3V21H10V14Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const hardDrive: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22 12H2M22 12V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V12M22 12L18.55 5.11C18.3844 4.77679 18.1292 4.49637 17.813 4.30028C17.4967 4.10419 17.1321 4.0002 16.76 4H7.24C6.86792 4.0002 6.50326 4.10419 6.18704 4.30028C5.87083 4.49637 5.61558 4.77679 5.45 5.11L2 12M6 16H6.01M10 16H10.01"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const hash: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M4 9H20M4 15H20M10 3L8 21M16 3L14 21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const headphones: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M3 18V12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12V18M21 19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H18C17.4696 21 16.9609 20.7893 16.5858 20.4142C16.2107 20.0391 16 19.5304 16 19V16C16 15.4696 16.2107 14.9609 16.5858 14.5858C16.9609 14.2107 17.4696 14 18 14H21V19ZM3 19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H6C6.53043 21 7.03914 20.7893 7.41421 20.4142C7.78929 20.0391 8 19.5304 8 19V16C8 15.4696 7.78929 14.9609 7.41421 14.5858C7.03914 14.2107 6.53043 14 6 14H3V19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const heart: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M20.8401 4.60999C20.3294 4.099 19.7229 3.69364 19.0555 3.41708C18.388 3.14052 17.6726 2.99817 16.9501 2.99817C16.2276 2.99817 15.5122 3.14052 14.8448 3.41708C14.1773 3.69364 13.5709 4.099 13.0601 4.60999L12.0001 5.66999L10.9401 4.60999C9.90843 3.5783 8.50915 2.9987 7.05012 2.9987C5.59109 2.9987 4.19181 3.5783 3.16012 4.60999C2.12843 5.64169 1.54883 7.04096 1.54883 8.49999C1.54883 9.95903 2.12843 11.3583 3.16012 12.39L4.22012 13.45L12.0001 21.23L19.7801 13.45L20.8401 12.39C21.3511 11.8792 21.7565 11.2728 22.033 10.6053C22.3096 9.93789 22.4519 9.22248 22.4519 8.49999C22.4519 7.77751 22.3096 7.0621 22.033 6.39464C21.7565 5.72718 21.3511 5.12075 20.8401 4.60999V4.60999Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const helpCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const hexagon: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 16V7.99999C20.9996 7.64927 20.9071 7.3048 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.26999L13 2.26999C12.696 2.09446 12.3511 2.00204 12 2.00204C11.6489 2.00204 11.304 2.09446 11 2.26999L4 6.26999C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.3048 3.00036 7.64927 3 7.99999V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const home: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 22V12H15V22M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const image: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21ZM5 21L16 10L21 15M10 8.5C10 9.32843 9.32843 10 8.5 10C7.67157 10 7 9.32843 7 8.5C7 7.67157 7.67157 7 8.5 7C9.32843 7 10 7.67157 10 8.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const inbox: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22 12H16L14 15H10L8 12H2M22 12V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V12M22 12L18.55 5.11C18.3844 4.77679 18.1292 4.49637 17.813 4.30028C17.4967 4.10419 17.1321 4.0002 16.76 4H7.24C6.86792 4.0002 6.50326 4.10419 6.18704 4.30028C5.87083 4.49637 5.61558 4.77679 5.45 5.11L2 12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const info: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const instagram: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M17.5 6.5H17.51M7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2ZM16 11.37C16.1234 12.2022 15.9813 13.0522 15.5938 13.799C15.2063 14.5458 14.5931 15.1514 13.8416 15.5297C13.0901 15.9079 12.2384 16.0396 11.4078 15.9059C10.5771 15.7723 9.80976 15.3801 9.21484 14.7852C8.61992 14.1902 8.22773 13.4229 8.09407 12.5922C7.9604 11.7616 8.09207 10.9099 8.47033 10.1584C8.84859 9.40685 9.45419 8.79374 10.201 8.40624C10.9478 8.01874 11.7978 7.87659 12.63 8C13.4789 8.12588 14.2649 8.52146 14.8717 9.12831C15.4785 9.73515 15.8741 10.5211 16 11.37Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const italic: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M19 4H10M14 20H5M15 4L9 20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const key: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15.4998 7.5L18.9998 4M20.9998 2L18.9998 4L20.9998 2ZM11.3898 11.61C11.9061 12.1195 12.3166 12.726 12.5975 13.3948C12.8785 14.0635 13.0244 14.7813 13.0268 15.5066C13.0292 16.232 12.8882 16.9507 12.6117 17.6213C12.3352 18.2919 11.9288 18.9012 11.4159 19.4141C10.903 19.9271 10.2937 20.3334 9.62309 20.6099C8.95247 20.8864 8.23379 21.0275 7.50842 21.025C6.78305 21.0226 6.06533 20.8767 5.39658 20.5958C4.72782 20.3148 4.12125 19.9043 3.61179 19.388C2.60992 18.3507 2.05555 16.9614 2.06808 15.5193C2.08061 14.0772 2.65904 12.6977 3.67878 11.678C4.69853 10.6583 6.078 10.0798 7.52008 10.0673C8.96216 10.0548 10.3515 10.6091 11.3888 11.611L11.3898 11.61ZM11.3898 11.61L15.4998 7.5L11.3898 11.61ZM15.4998 7.5L18.4998 10.5L21.9998 7L18.9998 4L15.4998 7.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const layout: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M3 9H21M9 21V9M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const lifeBuoy: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M4.93 4.93L9.17 9.17M14.83 14.83L19.07 19.07M19.07 4.93L14.83 9.17L18.36 5.64M4.93 19.07L9.17 14.83M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const link2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 17H6C5.34339 17 4.69321 16.8707 4.08658 16.6194C3.47995 16.3681 2.92876 15.9998 2.46447 15.5355C1.52678 14.5979 1 13.3261 1 12C1 10.6739 1.52678 9.40215 2.46447 8.46447C3.40215 7.52678 4.67392 7 6 7H9M8 12H16M15 7H18C18.6566 7 19.3068 7.12933 19.9134 7.3806C20.52 7.63188 21.0712 8.00017 21.5355 8.46447C21.9998 8.92876 22.3681 9.47996 22.6194 10.0866C22.8707 10.6932 23 11.3434 23 12C23 12.6566 22.8707 13.3068 22.6194 13.9134C22.3681 14.52 21.9998 15.0712 21.5355 15.5355C21.0712 15.9998 20.52 16.3681 19.9134 16.6194C19.3068 16.8707 18.6566 17 18 17H15V7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const link: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10.0002 13C10.4297 13.5742 10.9776 14.0492 11.6067 14.393C12.2359 14.7367 12.9317 14.9411 13.6468 14.9924C14.362 15.0436 15.0798 14.9404 15.7515 14.6898C16.4233 14.4392 17.0333 14.0471 17.5402 13.54L20.5402 10.54C21.451 9.59702 21.955 8.334 21.9436 7.02302C21.9322 5.71204 21.4063 4.45797 20.4793 3.53093C19.5523 2.60389 18.2982 2.07805 16.9872 2.06666C15.6762 2.05526 14.4132 2.55924 13.4702 3.47003L11.7502 5.18003M14.0002 11C13.5707 10.4259 13.0228 9.95084 12.3936 9.60709C11.7645 9.26333 11.0687 9.05891 10.3535 9.00769C9.63841 8.95648 8.92061 9.05966 8.24885 9.31025C7.5771 9.56083 6.96709 9.95296 6.4602 10.46L3.4602 13.46C2.54941 14.403 2.04544 15.666 2.05683 16.977C2.06822 18.288 2.59407 19.5421 3.52111 20.4691C4.44815 21.3962 5.70221 21.922 7.01319 21.9334C8.32418 21.9448 9.58719 21.4408 10.5302 20.53L12.2402 18.82"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const linkedin: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6 9H2V21H6V9Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const list: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const loader: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const lock: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11M5 11H19C20.1046 11 21 11.8954 21 13V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V13C3 11.8954 3.89543 11 5 11Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const logIn: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15M10 17L15 12M15 12L10 7M15 12H3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const logOut: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9M16 17L21 12M21 12L16 7M21 12H9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const mail: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6M22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6M22 6L12 13L2 6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const mapPin: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const map: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 18L1 22V6L8 2M8 18L16 22M8 18V2M16 22L23 18V2L16 6M16 22V6M16 6L8 2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const maximize2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15 3H21M21 3V9M21 3L14 10M9 21H3M3 21V15M3 21L10 14"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const maximize: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V8M21 8V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H16M16 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V16M3 16V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const meh: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 15H16M9 9H9.01M15 9H15.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const menu2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M3 12H17M3 6H21M3 18H21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const menu: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M3 12H21M3 6H21M3 18H21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const messageCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const messageSquare: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const micOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6596)">
      <path
        d="M1 0.99997L23 23M15 9.33997V3.99997C15.0007 3.256 14.725 2.53829 14.2264 1.98617C13.7277 1.43405 13.0417 1.08691 12.3015 1.01214C11.5613 0.937375 10.8197 1.14031 10.2207 1.58156C9.62172 2.0228 9.20805 2.67088 9.06 3.39997M17 16.95C16.0238 17.9464 14.7721 18.6284 13.4056 18.9086C12.0391 19.1887 10.62 19.0542 9.3305 18.5223C8.04096 17.9903 6.93976 17.0852 6.16817 15.9231C5.39658 14.761 4.98979 13.3949 5 12V9.99997M19 9.99997V12C18.9996 12.4124 18.9628 12.824 18.89 13.23M12 19V23M8 23H16M9 8.99997V12C9.00052 12.5929 9.17675 13.1724 9.50643 13.6653C9.83611 14.1582 10.3045 14.5423 10.8523 14.7691C11.4002 14.996 12.0029 15.0554 12.5845 14.9398C13.1661 14.8243 13.7005 14.539 14.12 14.12L9 8.99997Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6596">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const mic: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M19 10V12C19 13.8565 18.2625 15.637 16.9497 16.9497C15.637 18.2625 13.8565 19 12 19M12 19C10.1435 19 8.36301 18.2625 7.05025 16.9497C5.7375 15.637 5 13.8565 5 12V10M12 19V23M8 23H16M12 1C11.2044 1 10.4413 1.31607 9.87868 1.87868C9.31607 2.44129 9 3.20435 9 4V12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12V4C15 3.20435 14.6839 2.44129 14.1213 1.87868C13.5587 1.31607 12.7956 1 12 1Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const minimize2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M4 14H10M10 14V20M10 14L3 21M20 10H14M14 10V4M14 10L21 3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const minimize: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 3V6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8H3M21 8H18C17.4696 8 16.9609 7.78929 16.5858 7.41421C16.2107 7.03914 16 6.53043 16 6V3M16 21V18C16 17.4696 16.2107 16.9609 16.5858 16.5858C16.9609 16.2107 17.4696 16 18 16H21M3 16H6C6.53043 16 7.03914 16.2107 7.41421 16.5858C7.78929 16.9609 8 17.4696 8 18V21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const minusCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const minusSquare: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 12H16M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const minus: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M5 12H19" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const monitor: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 21H16M12 17V21M4 3H20C21.1046 3 22 3.89543 22 5V15C22 16.1046 21.1046 17 20 17H4C2.89543 17 2 16.1046 2 15V5C2 3.89543 2.89543 3 4 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const moon: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M20.9999 12.79C20.8426 14.4922 20.2038 16.1144 19.1581 17.4668C18.1125 18.8192 16.7034 19.8458 15.0956 20.4265C13.4878 21.0073 11.7479 21.1181 10.0794 20.7461C8.41092 20.3741 6.8829 19.5345 5.67413 18.3258C4.46536 17.117 3.62584 15.589 3.25381 13.9205C2.88178 12.252 2.99262 10.5121 3.57336 8.9043C4.15411 7.29651 5.18073 5.88737 6.53311 4.84175C7.8855 3.79614 9.5077 3.15731 11.2099 3C10.2133 4.34827 9.73375 6.00945 9.85843 7.68141C9.98312 9.35338 10.7038 10.9251 11.8893 12.1106C13.0748 13.2961 14.6465 14.0168 16.3185 14.1415C17.9905 14.2662 19.6516 13.7866 20.9999 12.79Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const moreHorizontal: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const moreVertical: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const mot: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12.1006 12.0968L8.89719 6.54873L5.69453 12.0968H12.1006ZM12.1006 12.0968H18.5069L15.3042 6.54873L12.1006 12.0968ZM12.1003 12.1013L15.303 17.6486H8.89688L12.1003 12.1013ZM22.2 12.1C22.2 17.6781 17.6781 22.2 12.1 22.2C6.52192 22.2 2 17.6781 2 12.1C2 6.52192 6.52192 2 12.1 2C17.6781 2 22.2 6.52192 22.2 12.1Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const mousePointer: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M13 13L19 19M3 3L10.07 19.97L12.58 12.58L19.97 10.07L3 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const move: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5 9L2 12M2 12L5 15M2 12H22M9 5L12 2M12 2L15 5M12 2V22M15 19L12 22M12 22L9 19M19 9L22 12M22 12L19 15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const music: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 18V5L21 3V16M9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18ZM21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const navigation2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 2L19 21L12 17L5 21L12 2Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const navigation: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M3 11L22 2L13 21L11 13L3 11Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const octagon: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const packageIcon: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16.5 9.40002L7.5 4.21002M3.27 6.96002L12 12.01L20.73 6.96002M12 22.08V12M21 16V8.00002C20.9996 7.6493 20.9071 7.30483 20.7315 7.00119C20.556 6.69754 20.3037 6.44539 20 6.27002L13 2.27002C12.696 2.09449 12.3511 2.00208 12 2.00208C11.6489 2.00208 11.304 2.09449 11 2.27002L4 6.27002C3.69626 6.44539 3.44398 6.69754 3.26846 7.00119C3.09294 7.30483 3.00036 7.6493 3 8.00002V16C3.00036 16.3508 3.09294 16.6952 3.26846 16.9989C3.44398 17.3025 3.69626 17.5547 4 17.73L11 21.73C11.304 21.9056 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9056 13 21.73L20 17.73C20.3037 17.5547 20.556 17.3025 20.7315 16.9989C20.9071 16.6952 20.9996 16.3508 21 16Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const paperclip: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21.4398 11.05L12.2498 20.24C11.124 21.3658 9.59699 21.9983 8.0048 21.9983C6.41262 21.9983 4.88565 21.3658 3.7598 20.24C2.63396 19.1141 2.00146 17.5872 2.00146 15.995C2.00146 14.4028 2.63396 12.8758 3.7598 11.75L12.9498 2.55998C13.7004 1.80942 14.7183 1.38776 15.7798 1.38776C16.8413 1.38776 17.8592 1.80942 18.6098 2.55998C19.3604 3.31054 19.782 4.32852 19.782 5.38998C19.782 6.45144 19.3604 7.46942 18.6098 8.21998L9.4098 17.41C9.03452 17.7853 8.52553 17.9961 7.9948 17.9961C7.46407 17.9961 6.95508 17.7853 6.5798 17.41C6.20452 17.0347 5.99369 16.5257 5.99369 15.995C5.99369 15.4643 6.20452 14.9553 6.5798 14.58L15.0698 6.09998"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const pauseCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10 15V9M14 15V9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const pause: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M10 4H6V20H10V4Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 4H14V20H18V4Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const penTool: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M2 2L16.5 5.5L18 13L13 18L5.5 16.5L2 2ZM2 2L9.586 9.586M12 19L19 12L22 15L15 22L12 19ZM13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const percent: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M19 5L5 19M9 6.5C9 7.88071 7.88071 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.88071 4 9 5.11929 9 6.5ZM20 17.5C20 18.8807 18.8807 20 17.5 20C16.1193 20 15 18.8807 15 17.5C15 16.1193 16.1193 15 17.5 15C18.8807 15 20 16.1193 20 17.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const phoneCall: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15.0499 5C16.0267 5.19057 16.9243 5.66826 17.628 6.37194C18.3317 7.07561 18.8094 7.97326 18.9999 8.95M15.0499 1C17.0792 1.22544 18.9715 2.13417 20.4162 3.57701C21.8608 5.01984 22.7719 6.91101 22.9999 8.94M21.9999 16.92V19.92C22.0011 20.1985 21.944 20.4742 21.8324 20.7293C21.7209 20.9845 21.5572 21.2136 21.352 21.4019C21.1468 21.5901 20.9045 21.7335 20.6407 21.8227C20.3769 21.9119 20.0973 21.9451 19.8199 21.92C16.7428 21.5856 13.7869 20.5341 11.1899 18.85C8.77376 17.3147 6.72527 15.2662 5.18993 12.85C3.49991 10.2412 2.44818 7.27099 2.11993 4.18C2.09494 3.90347 2.12781 3.62476 2.21643 3.36162C2.30506 3.09849 2.4475 2.85669 2.6347 2.65162C2.82189 2.44655 3.04974 2.28271 3.30372 2.17052C3.55771 2.05833 3.83227 2.00026 4.10993 2H7.10993C7.59524 1.99522 8.06572 2.16708 8.43369 2.48353C8.80166 2.79999 9.04201 3.23945 9.10993 3.72C9.23656 4.68007 9.47138 5.62273 9.80993 6.53C9.94448 6.88792 9.9736 7.27691 9.89384 7.65088C9.81408 8.02485 9.6288 8.36811 9.35993 8.64L8.08993 9.91C9.51349 12.4135 11.5864 14.4864 14.0899 15.91L15.3599 14.64C15.6318 14.3711 15.9751 14.1858 16.3491 14.1061C16.723 14.0263 17.112 14.0555 17.4699 14.19C18.3772 14.5286 19.3199 14.7634 20.2799 14.89C20.7657 14.9585 21.2093 15.2032 21.5265 15.5775C21.8436 15.9518 22.0121 16.4296 21.9999 16.92Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const phoneForwarded: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M18.9999 1L22.9999 5M22.9999 5L18.9999 9M22.9999 5H14.9999M21.9999 16.92V19.92C22.0011 20.1985 21.944 20.4742 21.8324 20.7293C21.7209 20.9845 21.5572 21.2136 21.352 21.4019C21.1468 21.5901 20.9045 21.7335 20.6407 21.8227C20.3769 21.9119 20.0973 21.9451 19.8199 21.92C16.7428 21.5856 13.7869 20.5341 11.1899 18.85C8.77376 17.3147 6.72527 15.2662 5.18993 12.85C3.49991 10.2412 2.44818 7.27099 2.11993 4.18C2.09494 3.90347 2.12781 3.62476 2.21643 3.36162C2.30506 3.09849 2.4475 2.85669 2.6347 2.65162C2.82189 2.44655 3.04974 2.28271 3.30372 2.17052C3.55771 2.05833 3.83227 2.00026 4.10993 2H7.10993C7.59524 1.99522 8.06572 2.16708 8.43369 2.48353C8.80166 2.79999 9.04201 3.23945 9.10993 3.72C9.23656 4.68007 9.47138 5.62273 9.80993 6.53C9.94448 6.88792 9.9736 7.27691 9.89384 7.65088C9.81408 8.02485 9.6288 8.36811 9.35993 8.64L8.08993 9.91C9.51349 12.4135 11.5864 14.4864 14.0899 15.91L15.3599 14.64C15.6318 14.3711 15.9751 14.1858 16.3491 14.1061C16.723 14.0263 17.112 14.0555 17.4699 14.19C18.3772 14.5286 19.3199 14.7634 20.2799 14.89C20.7657 14.9585 21.2093 15.2032 21.5265 15.5775C21.8436 15.9518 22.0121 16.4296 21.9999 16.92Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const phoneIncoming: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15.9999 2V8M15.9999 8H21.9999M15.9999 8L22.9999 1M21.9999 16.92V19.92C22.0011 20.1985 21.944 20.4742 21.8324 20.7293C21.7209 20.9845 21.5572 21.2136 21.352 21.4019C21.1468 21.5901 20.9045 21.7335 20.6407 21.8227C20.3769 21.9119 20.0973 21.9451 19.8199 21.92C16.7428 21.5856 13.7869 20.5341 11.1899 18.85C8.77376 17.3147 6.72527 15.2662 5.18993 12.85C3.49991 10.2412 2.44818 7.27099 2.11993 4.18C2.09494 3.90347 2.12781 3.62476 2.21643 3.36162C2.30506 3.09849 2.4475 2.85669 2.6347 2.65162C2.82189 2.44655 3.04974 2.28271 3.30372 2.17052C3.55771 2.05833 3.83227 2.00026 4.10993 2H7.10993C7.59524 1.99522 8.06572 2.16708 8.43369 2.48353C8.80166 2.79999 9.04201 3.23945 9.10993 3.72C9.23656 4.68007 9.47138 5.62273 9.80993 6.53C9.94448 6.88792 9.9736 7.27691 9.89384 7.65088C9.81408 8.02485 9.6288 8.36811 9.35993 8.64L8.08993 9.91C9.51349 12.4135 11.5864 14.4864 14.0899 15.91L15.3599 14.64C15.6318 14.3711 15.9751 14.1858 16.3491 14.1061C16.723 14.0263 17.112 14.0555 17.4699 14.19C18.3772 14.5286 19.3199 14.7634 20.2799 14.89C20.7657 14.9585 21.2093 15.2032 21.5265 15.5775C21.8436 15.9518 22.0121 16.4296 21.9999 16.92Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const phoneMissed: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22.9999 1L16.9999 7M16.9999 1L22.9999 7M21.9999 16.92V19.92C22.0011 20.1985 21.944 20.4742 21.8324 20.7293C21.7209 20.9845 21.5572 21.2136 21.352 21.4019C21.1468 21.5901 20.9045 21.7335 20.6407 21.8227C20.3769 21.9119 20.0973 21.9451 19.8199 21.92C16.7428 21.5856 13.7869 20.5341 11.1899 18.85C8.77376 17.3147 6.72527 15.2662 5.18993 12.85C3.49991 10.2412 2.44818 7.27099 2.11993 4.18C2.09494 3.90347 2.12781 3.62476 2.21643 3.36162C2.30506 3.09849 2.4475 2.85669 2.6347 2.65162C2.82189 2.44655 3.04974 2.28271 3.30372 2.17052C3.55771 2.05833 3.83227 2.00026 4.10993 2H7.10993C7.59524 1.99522 8.06572 2.16708 8.43369 2.48353C8.80166 2.79999 9.04201 3.23945 9.10993 3.72C9.23656 4.68007 9.47138 5.62273 9.80993 6.53C9.94448 6.88792 9.9736 7.27691 9.89384 7.65088C9.81408 8.02485 9.6288 8.36811 9.35993 8.64L8.08993 9.91C9.51349 12.4135 11.5864 14.4864 14.0899 15.91L15.3599 14.64C15.6318 14.3711 15.9751 14.1858 16.3491 14.1061C16.723 14.0263 17.112 14.0555 17.4699 14.19C18.3772 14.5286 19.3199 14.7634 20.2799 14.89C20.7657 14.9585 21.2093 15.2032 21.5265 15.5775C21.8436 15.9518 22.0121 16.4296 21.9999 16.92Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const phoneOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5.19 12.81C3.50586 10.213 2.45436 7.25717 2.12 4.18C2.09501 3.90347 2.12787 3.62476 2.2165 3.36162C2.30513 3.09849 2.44757 2.85669 2.63477 2.65162C2.82196 2.44655 3.0498 2.28271 3.30379 2.17052C3.55778 2.05833 3.83234 2.00026 4.11 2H7.11C7.59531 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04208 3.23945 9.11 3.72C9.23662 4.68007 9.47145 5.62273 9.81 6.53C9.94454 6.88792 9.97366 7.27691 9.89391 7.65088C9.81415 8.02485 9.62886 8.36811 9.36 8.64L8.09 9.91M23 1L1 23M10.68 13.31C11.6949 14.3257 12.8418 15.2003 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9752 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7606 14.9579 21.2 15.1983 21.5165 15.5662C21.8329 15.9342 22.0048 16.4047 22 16.89V19.89C22.0011 20.1685 21.9441 20.4442 21.8325 20.6993C21.7209 20.9545 21.5573 21.1836 21.3521 21.3719C21.1469 21.5601 20.9046 21.7035 20.6407 21.7927C20.3769 21.8819 20.0974 21.9151 19.82 21.89C16.7428 21.5556 13.787 20.5041 11.19 18.82C9.98527 18.0551 8.86853 17.1596 7.86 16.15L10.68 13.31Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const phoneOutgoing: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22.9999 7V1M22.9999 1H16.9999M22.9999 1L15.9999 8M21.9999 16.92V19.92C22.0011 20.1985 21.944 20.4742 21.8324 20.7293C21.7209 20.9845 21.5572 21.2136 21.352 21.4019C21.1468 21.5901 20.9045 21.7335 20.6407 21.8227C20.3769 21.9119 20.0973 21.9451 19.8199 21.92C16.7428 21.5856 13.7869 20.5341 11.1899 18.85C8.77376 17.3147 6.72527 15.2662 5.18993 12.85C3.49991 10.2412 2.44818 7.27099 2.11993 4.18C2.09494 3.90347 2.12781 3.62476 2.21643 3.36162C2.30506 3.09849 2.4475 2.85669 2.6347 2.65162C2.82189 2.44655 3.04974 2.28271 3.30372 2.17052C3.55771 2.05833 3.83227 2.00026 4.10993 2H7.10993C7.59524 1.99522 8.06572 2.16708 8.43369 2.48353C8.80166 2.79999 9.04201 3.23945 9.10993 3.72C9.23656 4.68007 9.47138 5.62273 9.80993 6.53C9.94448 6.88792 9.9736 7.27691 9.89384 7.65088C9.81408 8.02485 9.6288 8.36811 9.35993 8.64L8.08993 9.91C9.51349 12.4135 11.5864 14.4864 14.0899 15.91L15.3599 14.64C15.6318 14.3711 15.9751 14.1858 16.3491 14.1061C16.723 14.0263 17.112 14.0555 17.4699 14.19C18.3772 14.5286 19.3199 14.7634 20.2799 14.89C20.7657 14.9585 21.2093 15.2032 21.5265 15.5775C21.8436 15.9518 22.0121 16.4296 21.9999 16.92Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const phone: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21.9999 16.92V19.92C22.0011 20.1985 21.944 20.4741 21.8324 20.7293C21.7209 20.9845 21.5572 21.2136 21.352 21.4018C21.1468 21.5901 20.9045 21.7335 20.6407 21.8227C20.3769 21.9119 20.0973 21.945 19.8199 21.92C16.7428 21.5856 13.7869 20.5341 11.1899 18.85C8.77376 17.3146 6.72527 15.2661 5.18993 12.85C3.49991 10.2412 2.44818 7.27097 2.11993 4.17997C2.09494 3.90344 2.12781 3.62474 2.21643 3.3616C2.30506 3.09846 2.4475 2.85666 2.6347 2.6516C2.82189 2.44653 3.04974 2.28268 3.30372 2.1705C3.55771 2.05831 3.83227 2.00024 4.10993 1.99997H7.10993C7.59524 1.9952 8.06572 2.16705 8.43369 2.48351C8.80166 2.79996 9.04201 3.23942 9.10993 3.71997C9.23656 4.68004 9.47138 5.6227 9.80993 6.52997C9.94448 6.8879 9.9736 7.27689 9.89384 7.65086C9.81408 8.02482 9.6288 8.36809 9.35993 8.63998L8.08993 9.90997C9.51349 12.4135 11.5864 14.4864 14.0899 15.91L15.3599 14.64C15.6318 14.3711 15.9751 14.1858 16.3491 14.1061C16.723 14.0263 17.112 14.0554 17.4699 14.19C18.3772 14.5285 19.3199 14.7634 20.2799 14.89C20.7657 14.9585 21.2093 15.2032 21.5265 15.5775C21.8436 15.9518 22.0121 16.4296 21.9999 16.92Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const pieChart: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21.2099 15.89C20.5737 17.3945 19.5787 18.7202 18.3118 19.7513C17.0449 20.7824 15.5447 21.4874 13.9424 21.8048C12.34 22.1221 10.6843 22.0421 9.12006 21.5718C7.55578 21.1014 6.13054 20.2551 4.96893 19.1067C3.80733 17.9582 2.94473 16.5428 2.45655 14.9839C1.96837 13.4251 1.86948 11.7705 2.16851 10.1646C2.46755 8.55878 3.15541 7.05063 4.17196 5.77203C5.18851 4.49343 6.5028 3.48332 7.99992 2.83M21.9999 12C21.9999 10.6868 21.7413 9.38642 21.2387 8.17317C20.7362 6.95991 19.9996 5.85752 19.071 4.92893C18.1424 4.00035 17.04 3.26375 15.8267 2.7612C14.6135 2.25866 13.3131 2 11.9999 2V12H21.9999Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const playCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 8L16 12L10 16V8Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const play: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M5 3L19 12L5 21V3Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const plusCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const plusSquare: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 8V16M8 12H16M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const plusRectangle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M9,12h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12,9v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5,5c0-1.1.7-2,1.6-2h10.9c.9,0,1.6.9,1.6,2v14c0,1.1-.7,2-1.6,2H6.6c-.9,0-1.6-.9-1.6-2V5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const plus: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 5V19M5 12H19" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const pocket: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 10L12 14L16 10M4 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V11C22 13.6522 20.9464 16.1957 19.0711 18.0711C17.1957 19.9464 14.6522 21 12 21C10.6868 21 9.38642 20.7413 8.17317 20.2388C6.95991 19.7362 5.85752 18.9997 4.92893 18.0711C3.05357 16.1957 2 13.6522 2 11V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const poundSterling: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} stroke="none">
    <title>{props.title}</title>
    <path
      d="M8.13295 11.2312C8.13295 11.6558 7.78875 12 7.36416 12H0.809248C0.384659 12 0.0404623 11.6558 0.0404623 11.2312C0.0404623 10.8066 0.38466 10.4624 0.809248 10.4624H7.36416C7.78875 10.4624 8.13295 10.8066 8.13295 11.2312ZM5.7052 6.59538C5.7052 7.01996 5.361 7.36416 4.93642 7.36416H0.768786C0.344197 7.36416 0 7.01996 0 6.59538C0 6.17079 0.344197 5.82659 0.768786 5.82659H4.93642C5.361 5.82659 5.7052 6.17079 5.7052 6.59538ZM2.90173 3.66474L3.0867 8.65318C3.10983 9.15029 3.04624 9.59538 2.89595 9.98844C2.74566 10.3777 2.47399 10.6879 2.08092 10.9191L0.601156 10.4624C0.809248 10.4509 0.969171 10.3449 1.08092 10.1445C1.19268 9.94412 1.26782 9.70906 1.30636 9.43931C1.34489 9.1657 1.36031 8.91908 1.3526 8.69942L1.18497 3.66474C1.15414 2.85549 1.30443 2.17919 1.63584 1.63584C1.9711 1.09249 2.41618 0.684008 2.9711 0.410405C3.52601 0.136801 4.12331 0 4.76301 0C5.33333 0 5.84586 0.0944123 6.30058 0.283237C6.75915 0.472061 7.14451 0.73025 7.45665 1.0578C7.77264 1.3815 7.99807 1.75145 8.13295 2.16763C8.18106 2.31608 8.21544 2.46722 8.23609 2.62106C8.29977 3.09543 7.83486 3.41944 7.36218 3.3442C6.9027 3.27107 6.62973 2.82429 6.43479 2.40184C6.41396 2.35669 6.39042 2.31331 6.36416 2.27168C6.20616 2.0212 5.98844 1.83237 5.71098 1.7052C5.43353 1.57803 5.13873 1.51445 4.82659 1.51445C4.49904 1.51445 4.1869 1.59152 3.89017 1.74566C3.5973 1.89981 3.35838 2.13487 3.17341 2.45087C2.99229 2.76686 2.90173 3.17148 2.90173 3.66474Z"
      fill="#101828"
      stroke="none"
    />
  </svg>
));
export const power: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M18.3601 6.64C19.6185 7.89879 20.4754 9.50244 20.8224 11.2482C21.1694 12.9939 20.991 14.8034 20.3098 16.4478C19.6285 18.0921 18.4749 19.4976 16.9949 20.4864C15.515 21.4752 13.775 22.0029 11.9951 22.0029C10.2152 22.0029 8.47527 21.4752 6.99529 20.4864C5.51532 19.4976 4.36176 18.0921 3.68049 16.4478C2.99921 14.8034 2.82081 12.9939 3.16784 11.2482C3.51487 9.50244 4.37174 7.89879 5.63012 6.64M12.0001 2V12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const printer: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M6 9V2H18V9M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H18M6 14H18V22H6V14Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const radio: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16.2398 7.75999C16.7977 8.31723 17.2402 8.97896 17.5422 9.70735C17.8441 10.4357 17.9995 11.2165 17.9995 12.005C17.9995 12.7935 17.8441 13.5742 17.5422 14.3026C17.2402 15.031 16.7977 15.6928 16.2398 16.25M7.75982 16.24C7.20196 15.6828 6.75941 15.021 6.45746 14.2926C6.15551 13.5642 6.0001 12.7835 6.0001 11.995C6.0001 11.2065 6.15551 10.4257 6.45746 9.69735C6.75941 8.96896 7.20196 8.30723 7.75982 7.74999M19.0698 4.92999C20.9445 6.80527 21.9977 9.34835 21.9977 12C21.9977 14.6516 20.9445 17.1947 19.0698 19.07M4.92982 19.07C3.05511 17.1947 2.00195 14.6516 2.00195 12C2.00195 9.34835 3.05511 6.80527 4.92982 4.92999M13.9998 12C13.9998 13.1046 13.1044 14 11.9998 14C10.8952 14 9.99982 13.1046 9.99982 12C9.99982 10.8954 10.8952 9.99999 11.9998 9.99999C13.1044 9.99999 13.9998 10.8954 13.9998 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const refreshCcw: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M1 4.00001V10M1 10H7M1 10L5.64 5.64001C6.71475 4.56473 8.04437 3.77922 9.50481 3.35679C10.9652 2.93436 12.5089 2.88877 13.9917 3.22427C15.4745 3.55978 16.8482 4.26545 17.9845 5.27543C19.1209 6.28542 19.9828 7.5668 20.49 9.00001M23 20V14M23 14H17M23 14L18.36 18.36C17.2853 19.4353 15.9556 20.2208 14.4952 20.6432C13.0348 21.0657 11.4911 21.1113 10.0083 20.7758C8.52547 20.4402 7.1518 19.7346 6.01547 18.7246C4.87913 17.7146 4.01717 16.4332 3.51 15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const refreshCw: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M23 4.00001V10M23 10H17M23 10L18.36 5.64001C17.2853 4.56473 15.9556 3.77922 14.4952 3.35679C13.0348 2.93436 11.4911 2.88877 10.0083 3.22427C8.52547 3.55978 7.1518 4.26545 6.01547 5.27543C4.87913 6.28542 4.01717 7.5668 3.51 9.00001M1 20V14M1 14H7M1 14L5.64 18.36C6.71475 19.4353 8.04437 20.2208 9.50481 20.6432C10.9652 21.0657 12.5089 21.1113 13.9917 20.7758C15.4745 20.4402 16.8482 19.7346 17.9845 18.7246C19.1209 17.7146 19.9828 16.4332 20.49 15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const repeat: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M17 1L21 5M21 5L17 9M21 5H7C5.93913 5 4.92172 5.42143 4.17157 6.17157C3.42143 6.92172 3 7.93913 3 9V11M7 23L3 19M3 19L7 15M3 19H17C18.0609 19 19.0783 18.5786 19.8284 17.8284C20.5786 17.0783 21 16.0609 21 15V13"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const rewind: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M11 19L2 12L11 5V19Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 19L13 12L22 5V19Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const rocket: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M13.3248 10.6752L5.44059 18.5594M6.29145 12.8375L2.42965 11.9253C2.00478 11.825 1.85535 11.2975 2.16313 10.9886L5.23428 7.91744C5.44059 7.71113 5.72049 7.59292 6.01378 7.59069L9.47635 7.56059M13.8377 3.59842C16.4149 5.35591 18.6441 7.58512 20.4016 10.1623M11.1614 17.7085L12.0736 21.5703C12.1739 21.9952 12.7014 22.1447 13.0103 21.8369L16.0814 18.7657C16.2878 18.5594 16.406 18.2795 16.4082 17.9862L16.4383 14.5236M21.0629 8.35012L21.9639 4.01438C22.2093 2.83454 21.1655 1.79075 19.9856 2.03608L15.6499 2.93713C14.373 3.20254 13.2021 3.83483 12.281 4.75707L8.72362 8.31332C7.36647 9.67047 6.48326 11.4302 6.20447 13.3293L6.19221 13.4107C6.01601 14.6229 6.42193 15.8462 7.28729 16.7127C8.15266 17.5781 9.3771 17.984 10.5893 17.8067L10.6707 17.7944C12.5698 17.5167 14.3295 16.6324 15.6867 15.2753L19.2429 11.719C20.1652 10.7979 20.7975 9.62698 21.0629 8.35012Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const rotateCcw: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M1 4.00001V10M1 10H7M1 10L5.64 5.64001C7.02091 4.26143 8.81245 3.36898 10.7447 3.09713C12.6769 2.82527 14.6451 3.18874 16.3528 4.13277C18.0605 5.0768 19.4152 6.55025 20.2126 8.33111C21.0101 10.112 21.2072 12.1038 20.7742 14.0064C20.3413 15.909 19.3017 17.6194 17.8121 18.8798C16.3226 20.1402 14.4637 20.8824 12.5157 20.9945C10.5677 21.1066 8.63598 20.5826 7.01166 19.5014C5.38734 18.4202 4.15839 16.8404 3.51 15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const rotateCw: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22.9999 4.00001V10M22.9999 10H16.9999M22.9999 10L18.3699 5.64001C16.9905 4.25975 15.1999 3.3652 13.2678 3.09116C11.3358 2.81711 9.36705 3.17843 7.65823 4.12065C5.94942 5.06288 4.59313 6.53496 3.79374 8.31508C2.99436 10.0952 2.79519 12.0869 3.22625 13.9901C3.6573 15.8932 4.69524 17.6047 6.18363 18.8667C7.67203 20.1286 9.53026 20.8726 11.4783 20.9866C13.4263 21.1006 15.3586 20.5783 16.984 19.4985C18.6094 18.4187 19.8399 16.8399 20.4899 15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const rss: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M4 11C6.38695 11 8.67613 11.9482 10.364 13.636C12.0518 15.3239 13 17.6131 13 20M4 4C8.24346 4 12.3131 5.68571 15.3137 8.68629C18.3143 11.6869 20 15.7565 20 20M6 19C6 19.5523 5.55228 20 5 20C4.44772 20 4 19.5523 4 19C4 18.4477 4.44772 18 5 18C5.55228 18 6 18.4477 6 19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const save: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M17 21V13H7V21M7 3V8H15M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const scissors: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6ZM9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const search: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const send: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const server: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M6 6H6.01M6 18H6.01M4 2H20C21.1046 2 22 2.89543 22 4V8C22 9.10457 21.1046 10 20 10H4C2.89543 10 2 9.10457 2 8V4C2 2.89543 2.89543 2 4 2ZM4 14H20C21.1046 14 22 14.8954 22 16V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V16C2 14.8954 2.89543 14 4 14Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const settings: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const share2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const share: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M4 12V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V12M16 6L12 2M12 2L8 6M12 2V15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const shieldOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M19.69 14C19.8911 13.3522 19.9955 12.6783 20 12V5L12 2L8.84 3.18M4.73 4.73L4 5V12C4 18 12 22 12 22C14.117 20.8829 16.0197 19.4001 17.62 17.62M1 1L23 23"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const shield: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const shoppingBag: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M3 6L6 2H18L21 6M3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6M3 6H21M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const shoppingCart: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6M10 21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21C8 20.4477 8.44772 20 9 20C9.55228 20 10 20.4477 10 21ZM21 21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21C19 20.4477 19.4477 20 20 20C20.5523 20 21 20.4477 21 21Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const shuffle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 3H21M21 3V8M21 3L4 20M21 16V21M21 21H16M21 21L15 15M4 4L9 9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const sidebar: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 3V21M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const skipBack: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M5 19V5M19 20L9 12L19 4V20Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const skipForward: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M19 5V19M5 4L15 12L5 20V4Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const slack: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M14.5 10C13.67 10 13 9.33 13 8.5V3.5C13 2.67 13.67 2 14.5 2C15.33 2 16 2.67 16 3.5V8.5C16 9.33 15.33 10 14.5 10Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 10H19V8.5C19 7.67 19.67 7 20.5 7C21.33 7 22 7.67 22 8.5C22 9.33 21.33 10 20.5 10Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 14C10.33 14 11 14.67 11 15.5V20.5C11 21.33 10.33 22 9.5 22C8.67 22 8 21.33 8 20.5V15.5C8 14.67 8.67 14 9.5 14Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 14H5V15.5C5 16.33 4.33 17 3.5 17C2.67 17 2 16.33 2 15.5C2 14.67 2.67 14 3.5 14Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14.5C14 13.67 14.67 13 15.5 13H20.5C21.33 13 22 13.67 22 14.5C22 15.33 21.33 16 20.5 16H15.5C14.67 16 14 15.33 14 14.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 19H14V20.5C14 21.33 14.67 22 15.5 22C16.33 22 17 21.33 17 20.5C17 19.67 16.33 19 15.5 19Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 9.5C10 8.67 9.33 8 8.5 8H3.5C2.67 8 2 8.67 2 9.5C2 10.33 2.67 11 3.5 11H8.5C9.33 11 10 10.33 10 9.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2C7.67 2 7 2.67 7 3.5C7 4.33 7.67 5 8.5 5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const slashDivider: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <line
      x1="7.51631"
      y1="22.1711"
      x2="16.8139"
      y2="2.2323"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const slash: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const sliders: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M4 21V14M4 10V3M12 21V12M12 8V3M20 21V16M20 12V3M1 14H7M9 8H15M17 16H23"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const smartphone: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 18H12.01M7 2H17C18.1046 2 19 2.89543 19 4V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V4C5 2.89543 5.89543 2 7 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const smile: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M9 9H9.01M15 9H15.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const speaker: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 6H12.01M6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2ZM16 14C16 16.2091 14.2091 18 12 18C9.79086 18 8 16.2091 8 14C8 11.7909 9.79086 10 12 10C14.2091 10 16 11.7909 16 14Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const square: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const star: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const stopCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M15 9H9V15H15V9Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const sun: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 1V3M12 21V23M4.22 4.22L5.64 5.64M18.36 18.36L19.78 19.78M1 12H3M21 12H23M4.22 19.78L5.64 18.36M18.36 5.64L19.78 4.22M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const sunOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 1V3M12 21V23M4.22 4.22L5.64 5.64M18.36 18.36L19.78 19.78M1 12H3M21 12H23M4.22 19.78L5.64 18.36M18.36 5.64L19.78 4.22M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1="3" y1="21" x2="21" y2="3" stroke="#323232" strokeWidth="2" strokeLinecap="round" />
  </svg>
));
export const sunrise: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M17 18C17 16.6739 16.4732 15.4021 15.5355 14.4645C14.5979 13.5268 13.3261 13 12 13C10.6739 13 9.40215 13.5268 8.46447 14.4645C7.52678 15.4021 7 16.6739 7 18M12 2V9M12 2L8 6M12 2L16 6M4.22 10.22L5.64 11.64M1 18H3M21 18H23M18.36 11.64L19.78 10.22M23 22H1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const sunset: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M17 18C17 16.6739 16.4732 15.4021 15.5355 14.4645C14.5979 13.5268 13.3261 13 12 13C10.6739 13 9.40215 13.5268 8.46447 14.4645C7.52678 15.4021 7 16.6739 7 18M12 9V2M12 9L16 5M12 9L8 5M4.22 10.22L5.64 11.64M1 18H3M21 18H23M18.36 11.64L19.78 10.22M23 22H1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const tablet: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 18H12.01M6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const tag: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M7.5 7.5H7.51M21.09 13.91L13.92 21.08C13.7343 21.266 13.5137 21.4135 13.2709 21.5141C13.0281 21.6148 12.7678 21.6666 12.505 21.6666C12.2422 21.6666 11.9819 21.6148 11.7391 21.5141C11.4963 21.4135 11.2757 21.266 11.09 21.08L2.5 12.5V2.5H12.5L21.09 11.09C21.4625 11.4647 21.6716 11.9716 21.6716 12.5C21.6716 13.0284 21.4625 13.5353 21.09 13.91Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const target: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const terminal: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M4 17L10 11L4 5M12 19H20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const thermometer: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6489)">
      <path
        d="M14 14.76V3.5C14 2.83696 13.7366 2.20107 13.2678 1.73223C12.7989 1.26339 12.163 1 11.5 1C10.837 1 10.2011 1.26339 9.73223 1.73223C9.26339 2.20107 9 2.83696 9 3.5V14.76C8.19728 15.2963 7.58832 16.0766 7.26307 16.9856C6.93782 17.8946 6.91352 18.8841 7.19376 19.8079C7.47399 20.7317 8.04391 21.541 8.81934 22.1161C9.59476 22.6912 10.5346 23.0017 11.5 23.0017C12.4654 23.0017 13.4052 22.6912 14.1807 22.1161C14.9561 21.541 15.526 20.7317 15.8062 19.8079C16.0865 18.8841 16.0622 17.8946 15.7369 16.9856C15.4117 16.0766 14.8027 15.2963 14 14.76Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6489">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const thumbsDown: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M17 2H19.67C20.236 1.98999 20.7859 2.18813 21.2154 2.55681C21.645 2.9255 21.9242 3.43905 22 4V11C21.9242 11.5609 21.645 12.0745 21.2154 12.4432C20.7859 12.8119 20.236 13.01 19.67 13H17M10 15V19C10 19.7956 10.3161 20.5587 10.8787 21.1213C11.4413 21.6839 12.2044 22 13 22L17 13V2H5.72003C5.2377 1.99454 4.76965 2.16359 4.40212 2.47599C4.0346 2.78839 3.79235 3.22309 3.72003 3.7L2.34003 12.7C2.29652 12.9866 2.31586 13.2793 2.39669 13.5577C2.47753 13.8362 2.61793 14.0937 2.80817 14.3125C2.99842 14.5313 3.23395 14.7061 3.49846 14.8248C3.76297 14.9435 4.05012 15.0033 4.34003 15H10Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const thumbsUp: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M7 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V13C2 12.4696 2.21071 11.9609 2.58579 11.5858C2.96086 11.2107 3.46957 11 4 11H7M14 9V5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2L7 11V22H18.28C18.7623 22.0055 19.2304 21.8364 19.5979 21.524C19.9654 21.2116 20.2077 20.7769 20.28 20.3L21.66 11.3C21.7035 11.0134 21.6842 10.7207 21.6033 10.4423C21.5225 10.1638 21.3821 9.90629 21.1919 9.68751C21.0016 9.46873 20.7661 9.29393 20.5016 9.17522C20.2371 9.0565 19.9499 8.99672 19.66 9H14Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const toggleLeft: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 5H8C4.13401 5 1 8.13401 1 12C1 15.866 4.13401 19 8 19H16C19.866 19 23 15.866 23 12C23 8.13401 19.866 5 16 5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const toggleRight: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 5H8C4.13401 5 1 8.13401 1 12C1 15.866 4.13401 19 8 19H16C19.866 19 23 15.866 23 12C23 8.13401 19.866 5 16 5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const tool: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M14.6999 6.29998C14.5166 6.48691 14.414 6.73823 14.414 6.99998C14.414 7.26173 14.5166 7.51305 14.6999 7.69998L16.2999 9.29998C16.4868 9.48321 16.7381 9.58584 16.9999 9.58584C17.2616 9.58584 17.5129 9.48321 17.6999 9.29998L21.4699 5.52998C21.9727 6.64117 22.1249 7.87921 21.9063 9.07913C21.6877 10.279 21.1086 11.3838 20.2461 12.2463C19.3837 13.1087 18.2789 13.6878 17.079 13.9064C15.8791 14.1251 14.641 13.9728 13.5299 13.47L6.61986 20.38C6.22203 20.7778 5.68246 21.0013 5.11986 21.0013C4.55725 21.0013 4.01768 20.7778 3.61986 20.38C3.22203 19.9822 2.99854 19.4426 2.99854 18.88C2.99854 18.3174 3.22203 17.7778 3.61986 17.38L10.5299 10.47C10.027 9.35879 9.87477 8.12075 10.0934 6.92083C10.312 5.72092 10.8911 4.61614 11.7536 3.7537C12.616 2.89127 13.7208 2.31215 14.9207 2.09352C16.1206 1.8749 17.3587 2.02714 18.4699 2.52998L14.7099 6.28998L14.6999 6.29998Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const trash2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M10 11V17M14 11V17"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const trash: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const trello: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 7H7V16H10V7Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 7H14V12H17V7Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const trendingDown: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M23 18L13.5 8.5L8.5 13.5L1 6M23 18H17M23 18V12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const trendingUp: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M23 6L13.5 15.5L8.5 10.5L1 18M23 6H17M23 6V12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const triangle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10.2898 3.85996L1.81978 18C1.64514 18.3024 1.55274 18.6453 1.55177 18.9945C1.55079 19.3437 1.64127 19.6871 1.8142 19.9905C1.98714 20.2939 2.2365 20.5467 2.53748 20.7238C2.83847 20.9009 3.18058 20.9961 3.52978 21H20.4698C20.819 20.9961 21.1611 20.9009 21.4621 20.7238C21.7631 20.5467 22.0124 20.2939 22.1854 19.9905C22.3583 19.6871 22.4488 19.3437 22.4478 18.9945C22.4468 18.6453 22.3544 18.3024 22.1798 18L13.7098 3.85996C13.5315 3.56607 13.2805 3.32308 12.981 3.15444C12.6814 2.98581 12.3435 2.89722 11.9998 2.89722C11.656 2.89722 11.3181 2.98581 11.0186 3.15444C10.7191 3.32308 10.468 3.56607 10.2898 3.85996V3.85996Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const truck: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 16V3H1V16H16ZM16 16H23V11L20 8H16V16ZM8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11929 16 5.5 16C6.88071 16 8 17.1193 8 18.5ZM21 18.5C21 19.8807 19.8807 21 18.5 21C17.1193 21 16 19.8807 16 18.5C16 17.1193 17.1193 16 18.5 16C19.8807 16 21 17.1193 21 18.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const tv: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M17 2L12 7L7 2M4 7H20C21.1046 7 22 7.89543 22 9V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V9C2 7.89543 2.89543 7 4 7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const twitch: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 11V7M21 2H3V18H8V22L12 18H17L21 14V2ZM11 11V7V11Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const twitter: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M23 3.00005C22.0424 3.67552 20.9821 4.19216 19.86 4.53005C19.2577 3.83756 18.4573 3.34674 17.567 3.12397C16.6767 2.90121 15.7395 2.95724 14.8821 3.2845C14.0247 3.61176 13.2884 4.19445 12.773 4.95376C12.2575 5.71308 11.9877 6.61238 12 7.53005V8.53005C10.2426 8.57561 8.50127 8.18586 6.93101 7.39549C5.36074 6.60513 4.01032 5.43868 3 4.00005C3 4.00005 -1 13 8 17C5.94053 18.398 3.48716 19.099 1 19C10 24 21 19 21 7.50005C20.9991 7.2215 20.9723 6.94364 20.92 6.67005C21.9406 5.66354 22.6608 4.39276 23 3.00005Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const type: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M4 7V4H20V7M9 20H15M12 4V20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const tyre: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M19.5595 9.56872C19.1312 9.22003 18.5014 9.28456 18.1527 9.71285C17.804 10.1411 17.8685 10.771 18.2968 11.1197L19.5595 9.56872ZM19.8197 12.3596C20.248 12.7083 20.8779 12.6437 21.2266 12.2154C21.5753 11.7872 21.5107 11.1573 21.0824 10.8086L19.8197 12.3596ZM2.06056 9.56872C1.63227 9.22003 1.0024 9.28456 0.653709 9.71285C0.305019 10.1411 0.369548 10.771 0.797839 11.1197L2.06056 9.56872ZM2.32076 12.3596C2.74905 12.7083 3.37892 12.6437 3.72761 12.2154C4.0763 11.7872 4.01177 11.1573 3.58348 10.8086L2.32076 12.3596ZM18.0229 16.0704C17.9666 15.521 17.4756 15.1213 16.9262 15.1775C16.3768 15.2338 15.977 15.7248 16.0333 16.2742L18.0229 16.0704ZM16.2334 18.2279C16.2897 18.7773 16.7807 19.1771 17.3301 19.1208C17.8795 19.0645 18.2793 18.5735 18.223 18.0241L16.2334 18.2279ZM5.65068 3.69822C5.5944 3.14881 5.10339 2.74905 4.55398 2.80533C4.00457 2.86161 3.60481 3.35262 3.66109 3.90203L5.65068 3.69822ZM3.86123 5.85571C3.91751 6.40512 4.40852 6.80488 4.95793 6.7486C5.50734 6.69232 5.9071 6.20131 5.85082 5.6519L3.86123 5.85571ZM12.3349 19.5836C12.6837 19.1554 12.6194 18.5256 12.1913 18.1767C11.7631 17.8279 11.1332 17.8921 10.7844 18.3203L12.3349 19.5836ZM9.54354 19.8432C9.19469 20.2714 9.25898 20.9013 9.68714 21.2501C10.1153 21.599 10.7452 21.5347 11.094 21.1065L9.54354 19.8432ZM12.3349 2.08627C12.6837 1.65811 12.6194 1.02822 12.1913 0.679365C11.7631 0.330514 11.1332 0.394807 10.7844 0.822968L12.3349 2.08627ZM9.54354 2.34589C9.19469 2.77405 9.25898 3.40394 9.68714 3.75279C10.1153 4.10164 10.7452 4.03735 11.094 3.60919L9.54354 2.34589ZM5.83353 18.0451C6.38294 17.9888 6.7827 17.4978 6.72642 16.9484C6.67014 16.399 6.17913 15.9992 5.62972 16.0555L5.83353 18.0451ZM3.67604 16.2556C3.12663 16.3119 2.72687 16.8029 2.78315 17.3523C2.83943 17.9017 3.33044 18.3015 3.87985 18.2452L3.67604 16.2556ZM18.2074 5.66962C18.7568 5.61334 19.1565 5.12233 19.1003 4.57292C19.044 4.02351 18.553 3.62375 18.0036 3.68003L18.2074 5.66962ZM16.0499 3.88017C15.5005 3.93645 15.1007 4.42746 15.157 4.97687C15.2133 5.52628 15.7043 5.92604 16.2537 5.86976L16.0499 3.88017ZM19.5715 11.0063C19.5715 15.74 15.7341 19.5775 11.0003 19.5775V21.5775C16.8386 21.5775 21.5715 16.8446 21.5715 11.0063H19.5715ZM11.0003 19.5775C6.26663 19.5775 2.4292 15.74 2.4292 11.0063H0.429199C0.429199 16.8446 5.16206 21.5775 11.0003 21.5775V19.5775ZM2.4292 11.0063C2.4292 6.27261 6.26663 2.43518 11.0003 2.43518V0.435181C5.16206 0.435181 0.429199 5.16804 0.429199 11.0063H2.4292ZM11.0003 2.43518C15.7341 2.43518 19.5715 6.27261 19.5715 11.0063H21.5715C21.5715 5.16804 16.8386 0.435181 11.0003 0.435181V2.43518ZM14.8538 11.0035C14.8538 13.1324 13.128 14.8582 10.9992 14.8582V16.8582C14.2326 16.8582 16.8538 14.237 16.8538 11.0035H14.8538ZM10.9992 14.8582C8.8703 14.8582 7.14451 13.1324 7.14451 11.0035H5.14451C5.14451 14.237 7.76573 16.8582 10.9992 16.8582V14.8582ZM7.14451 11.0035C7.14451 8.87466 8.8703 7.14887 10.9992 7.14887V5.14887C7.76573 5.14887 5.14451 7.77009 5.14451 11.0035H7.14451ZM10.9992 7.14887C13.128 7.14887 14.8538 8.87466 14.8538 11.0035H16.8538C16.8538 7.77009 14.2326 5.14887 10.9992 5.14887V7.14887ZM18.2968 11.1197L19.8197 12.3596L21.0824 10.8086L19.5595 9.56872L18.2968 11.1197ZM0.797839 11.1197L2.32076 12.3596L3.58348 10.8086L2.06056 9.56872L0.797839 11.1197ZM16.0333 16.2742L16.2334 18.2279L18.223 18.0241L18.0229 16.0704L16.0333 16.2742ZM3.66109 3.90203L3.86123 5.85571L5.85082 5.6519L5.65068 3.69822L3.66109 3.90203ZM10.7844 18.3203L9.54354 19.8432L11.094 21.1065L12.3349 19.5836L10.7844 18.3203ZM10.7844 0.822968L9.54354 2.34589L11.094 3.60919L12.3349 2.08627L10.7844 0.822968ZM5.62972 16.0555L3.67604 16.2556L3.87985 18.2452L5.83353 18.0451L5.62972 16.0555ZM18.0036 3.68003L16.0499 3.88017L16.2537 5.86976L18.2074 5.66962L18.0036 3.68003Z"
      fill="#101828"
    />
  </svg>
));
export const umbrella: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M18 19C18 19.7956 17.6839 20.5587 17.1213 21.1213C16.5587 21.6839 15.7956 22 15 22C14.2044 22 13.4413 21.6839 12.8787 21.1213C12.3161 20.5587 12 19.7956 12 19V12M23 12C22.7388 9.26357 21.467 6.72275 19.433 4.87366C17.399 3.02458 14.7489 2 12 2C9.25114 2 6.60096 3.02458 4.56697 4.87366C2.53297 6.72275 1.2612 9.26357 1 12H23Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const underline: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M6 3V10C6 11.5913 6.63214 13.1174 7.75736 14.2426C8.88258 15.3679 10.4087 16 12 16C13.5913 16 15.1174 15.3679 16.2426 14.2426C17.3679 13.1174 18 11.5913 18 10V3M4 21H20"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const unlock: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M7 11V7.00003C6.99875 5.76008 7.45828 4.5639 8.28937 3.6437C9.12047 2.7235 10.2638 2.14493 11.4975 2.02032C12.7312 1.89571 13.9671 2.23393 14.9655 2.96934C15.9638 3.70475 16.6533 4.78488 16.9 6.00003M5 11H19C20.1046 11 21 11.8955 21 13V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V13C3 11.8955 3.89543 11 5 11Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const uploadCloud: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_155_6635)">
      <path
        d="M16 16L12 12M12 12L7.99996 16M12 12V21M20.39 18.39C21.3653 17.8583 22.1358 17.0169 22.5798 15.9986C23.0239 14.9804 23.1162 13.8432 22.8422 12.7667C22.5682 11.6901 21.9434 10.7355 21.0666 10.0534C20.1898 9.37137 19.1108 9.00072 18 8.99998H16.74C16.4373 7.82923 15.8731 6.74232 15.0899 5.82098C14.3067 4.89964 13.3248 4.16783 12.2181 3.68059C11.1113 3.19335 9.90851 2.96334 8.70008 3.00787C7.49164 3.05239 6.30903 3.37028 5.24114 3.93765C4.17325 4.50501 3.24787 5.30709 2.53458 6.28357C1.82129 7.26004 1.33865 8.38552 1.12294 9.57538C0.90723 10.7652 0.964065 11.9885 1.28917 13.1532C1.61428 14.318 2.1992 15.3938 2.99996 16.3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_155_6635">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const upload: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const uploadOutlined: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="47" height="46" viewBox="0 0 47 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <rect x="3.5" y="3" width="40" height="40" rx="20" fill="#F2F4F7" />
    <path
      d="M31 25.5V28.8333C31 29.2754 30.8244 29.6993 30.5118 30.0118C30.1993 30.3244 29.7754 30.5 29.3333 30.5H17.6667C17.2246 30.5 16.8007 30.3244 16.4882 30.0118C16.1756 29.6993 16 29.2754 16 28.8333V25.5M27.6667 19.6667L23.5 15.5M23.5 15.5L19.3333 19.6667M23.5 15.5V25.5"
      stroke="#475467"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="3.5" y="3" width="40" height="40" rx="20" stroke="#F9FAFB" strokeWidth="6" />
  </svg>
));
export const userCheck: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M17 11L19 13L23 9M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const userMinus: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 11H17M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const userPlus: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M20 8V14M23 11H17M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const userX: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M18 8L23 13M23 8L18 13M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const user: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const users: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const videoOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10.66 5H14C14.5304 5 15.0391 5.21071 15.4142 5.58579C15.7893 5.96086 16 6.46957 16 7V10.34L17 11.34L23 7V17M1 1L23 23M16 16V17C16 17.5304 15.7893 18.0391 15.4142 18.4142C15.0391 18.7893 14.5304 19 14 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V7C1 6.46957 1.21071 5.96086 1.58579 5.58579C1.96086 5.21071 2.46957 5 3 5H5L16 16Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const video: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M23 7L16 12L23 17V7Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M14 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H14C15.1046 19 16 18.1046 16 17V7C16 5.89543 15.1046 5 14 5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const voicemail: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5.5 16C7.98528 16 10 13.9853 10 11.5C10 9.01472 7.98528 7 5.5 7C3.01472 7 1 9.01472 1 11.5C1 13.9853 3.01472 16 5.5 16ZM5.5 16H18.5M18.5 16C20.9853 16 23 13.9853 23 11.5C23 9.01472 20.9853 7 18.5 7C16.0147 7 14 9.01472 14 11.5C14 13.9853 16.0147 16 18.5 16Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const volume1: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15.54 8.46C16.4774 9.39764 17.0039 10.6692 17.0039 11.995C17.0039 13.3208 16.4774 14.5924 15.54 15.53M11 5L6 9H2V15H6L11 19V5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const volume2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M19.07 4.93005C20.9447 6.80533 21.9979 9.34841 21.9979 12.0001C21.9979 14.6517 20.9447 17.1948 19.07 19.0701M15.54 8.46005C16.4774 9.39769 17.0039 10.6692 17.0039 11.9951C17.0039 13.3209 16.4774 14.5924 15.54 15.5301M11 5.00005L6 9.00005H2V15.0001H6L11 19.0001V5.00005Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const volumeX: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M23 9L17 15M17 9L23 15M11 5L6 9H2V15H6L11 19V5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const volume: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M11 5L6 9H2V15H6L11 19V5Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const watch: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M13 9.00002C13 8.44773 12.5523 8.00002 12 8.00002C11.4477 8.00002 11 8.44773 11 9.00002H13ZM12 12H11C11 12.2652 11.1054 12.5196 11.2929 12.7071L12 12ZM12.7929 14.2071C13.1834 14.5976 13.8166 14.5976 14.2071 14.2071C14.5976 13.8166 14.5976 13.1834 14.2071 12.7929L12.7929 14.2071ZM17.5059 17.441C17.5561 16.891 17.151 16.4044 16.601 16.3542C16.051 16.3039 15.5644 16.709 15.5141 17.259L17.5059 17.441ZM16.16 21.18L15.1641 21.089L15.1641 21.09L16.16 21.18ZM14.16 23L14.1641 22H14.16V23ZM9.83 23V22L9.82594 22L9.83 23ZM7.83 21.18L8.82594 21.09L8.82585 21.089L7.83 21.18ZM8.47585 17.259C8.42559 16.709 7.93899 16.3039 7.389 16.3542C6.839 16.4044 6.43389 16.891 6.48415 17.441L8.47585 17.259ZM6.49415 6.55901C6.44389 7.109 6.849 7.59561 7.399 7.64587C7.94899 7.69613 8.43559 7.29101 8.48585 6.74102L6.49415 6.55901ZM7.84 2.82002L8.83585 2.91102L8.83594 2.91002L7.84 2.82002ZM9.83 1.00002V1.60336e-05L9.82906 1.69277e-05L9.83 1.00002ZM14.18 1.00002V2.00002L14.1841 2.00001L14.18 1.00002ZM16.18 2.82002L15.1841 2.91001L15.1841 2.91102L16.18 2.82002ZM15.5342 6.74102C15.5844 7.29101 16.071 7.69613 16.621 7.64587C17.171 7.59561 17.5761 7.109 17.5259 6.55901L15.5342 6.74102ZM18 12C18 15.3137 15.3137 18 12 18V20C16.4183 20 20 16.4183 20 12H18ZM12 18C8.68629 18 6 15.3137 6 12H4C4 16.4183 7.58172 20 12 20V18ZM6 12C6 8.68631 8.68629 6.00002 12 6.00002V4.00002C7.58172 4.00002 4 7.58174 4 12H6ZM12 6.00002C15.3137 6.00002 18 8.68631 18 12H20C20 7.58174 16.4183 4.00002 12 4.00002V6.00002ZM11 9.00002V12H13V9.00002H11ZM11.2929 12.7071L12.7929 14.2071L14.2071 12.7929L12.7071 11.2929L11.2929 12.7071ZM15.5141 17.259L15.1641 21.089L17.1559 21.271L17.5059 17.441L15.5141 17.259ZM15.1641 21.09C15.1415 21.3393 15.0263 21.5712 14.8412 21.7396L16.1872 23.2188C16.7427 22.7134 17.0884 22.018 17.1559 21.27L15.1641 21.09ZM14.8412 21.7396C14.656 21.9081 14.4144 22.001 14.1641 22L14.1559 24C14.9069 24.0031 15.6318 23.7243 16.1872 23.2188L14.8412 21.7396ZM14.16 22H9.83V24H14.16V22ZM9.82594 22C9.57561 22.001 9.334 21.9081 9.14884 21.7396L7.80276 23.2188C8.35822 23.7243 9.08305 24.0031 9.83406 24L9.82594 22ZM9.14884 21.7396C8.96369 21.5712 8.84847 21.3393 8.82594 21.09L6.83406 21.27C6.90164 22.018 7.24731 22.7134 7.80276 23.2188L9.14884 21.7396ZM8.82585 21.089L8.47585 17.259L6.48415 17.441L6.83415 21.271L8.82585 21.089ZM8.48585 6.74102L8.83585 2.91102L6.84415 2.72901L6.49415 6.55901L8.48585 6.74102ZM8.83594 2.91002C8.85839 2.66156 8.97291 2.43046 9.157 2.26209L7.80723 0.786246C7.25495 1.29134 6.91142 1.98463 6.84406 2.73002L8.83594 2.91002ZM9.157 2.26209C9.34109 2.09373 9.58147 2.00025 9.83094 2.00002L9.82906 1.69277e-05C9.08064 0.000721812 8.35951 0.281148 7.80723 0.786246L9.157 2.26209ZM9.83 2.00002H14.18V1.65105e-05H9.83V2.00002ZM14.1841 2.00001C14.4344 1.99899 14.676 2.09191 14.8612 2.26039L16.2072 0.781184C15.6518 0.275722 14.9269 -0.00302255 14.1759 2.47359e-05L14.1841 2.00001ZM14.8612 2.26039C15.0463 2.42888 15.1615 2.66069 15.1841 2.91001L17.1759 2.73002C17.1084 1.98206 16.7627 1.28665 16.2072 0.781184L14.8612 2.26039ZM15.1841 2.91102L15.5342 6.74102L17.5259 6.55901L17.1759 2.72901L15.1841 2.91102Z"
      fill="#101828"
    />
  </svg>
));
export const wifiOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M1 1L23 23M16.72 11.06C17.5391 11.4598 18.305 11.9603 19 12.55M5 12.55C6.48208 11.3108 8.26587 10.4862 10.17 10.16M10.71 5.05C12.8524 4.87737 15.0076 5.13816 17.047 5.81682C19.0865 6.49548 20.9682 7.57808 22.58 9M1.42 9C2.80717 7.77385 4.3977 6.79923 6.12 6.12M8.53 16.11C9.5452 15.3887 10.7597 15.0013 12.005 15.0013C13.2503 15.0013 14.4648 15.3887 15.48 16.11M12 20H12.01"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const wifi: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M4.99992 12.55C6.97649 10.9037 9.46753 10.0022 12.0399 10.0022C14.6123 10.0022 17.1034 10.9037 19.0799 12.55M1.41992 9.00004C4.34234 6.424 8.10422 5.00269 11.9999 5.00269C15.8956 5.00269 19.6575 6.424 22.5799 9.00004M8.52992 16.11C9.54512 15.3888 10.7596 15.0013 12.0049 15.0013C13.2502 15.0013 14.4647 15.3888 15.4799 16.11M11.9999 20H12.0099"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const wind: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9.59 4.58998C9.82231 4.3563 10.1088 4.18363 10.4239 4.08732C10.739 3.99102 11.073 3.97407 11.3963 4.03797C11.7195 4.10188 12.022 4.24466 12.2768 4.45363C12.5315 4.66259 12.7307 4.93127 12.8566 5.23578C12.9825 5.54028 13.0313 5.87117 12.9985 6.19905C12.9657 6.52692 12.8524 6.84161 12.6687 7.11514C12.4849 7.38868 12.2365 7.61258 11.9454 7.76695C11.6542 7.92132 11.3295 8.00137 11 7.99998H2M12.59 19.41C12.8223 19.6437 13.1088 19.8163 13.4239 19.9126C13.739 20.0089 14.073 20.0259 14.3963 19.962C14.7195 19.8981 15.022 19.7553 15.2768 19.5463C15.5315 19.3374 15.7307 19.0687 15.8566 18.7642C15.9825 18.4597 16.0313 18.1288 15.9985 17.8009C15.9657 17.473 15.8524 17.1584 15.6687 16.8848C15.4849 16.6113 15.2365 16.3874 14.9454 16.233C14.6542 16.0786 14.3295 15.9986 14 16H2M17.73 7.72998C18.0208 7.43987 18.3787 7.2259 18.7719 7.10699C19.1652 6.98809 19.5816 6.96792 19.9845 7.04827C20.3874 7.12861 20.7642 7.307 21.0817 7.56765C21.3993 7.8283 21.6477 8.16318 21.805 8.54267C21.9623 8.92217 22.0236 9.33458 21.9836 9.74343C21.9436 10.1523 21.8035 10.545 21.5756 10.8868C21.3477 11.2286 21.0391 11.509 20.6771 11.7031C20.3151 11.8973 19.9108 11.9992 19.5 12H2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const xCircle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const xOctagon: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15 9L9 15M9 9L15 15M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const xSquare: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 9L15 15M15 9L9 15M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const x: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M18 6L6 18M6 6L18 18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const youtube: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M22.5401 6.42C22.4213 5.94541 22.1794 5.51057 21.8387 5.15941C21.4981 4.80824 21.0708 4.55318 20.6001 4.42C18.8801 4 12.0001 4 12.0001 4C12.0001 4 5.12008 4 3.40008 4.46C2.92933 4.59318 2.50206 4.84824 2.16143 5.19941C1.8208 5.55057 1.57887 5.98541 1.46008 6.46C1.1453 8.20556 0.991319 9.97631 1.00008 11.75C0.988863 13.537 1.14285 15.3213 1.46008 17.08C1.59104 17.5398 1.83839 17.9581 2.17823 18.2945C2.51806 18.6308 2.9389 18.8738 3.40008 19C5.12008 19.46 12.0001 19.46 12.0001 19.46C12.0001 19.46 18.8801 19.46 20.6001 19C21.0708 18.8668 21.4981 18.6118 21.8387 18.2606C22.1794 17.9094 22.4213 17.4746 22.5401 17C22.8524 15.2676 23.0064 13.5103 23.0001 11.75C23.0113 9.96295 22.8573 8.1787 22.5401 6.42Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75008 15.02L15.5001 11.75L9.75008 8.48V15.02Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const zapOff: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12.41 6.75L13 2L10.57 4.92M18.57 12.91L21 10H15.66M8 8L3 14H12L11 22L16 16M1 1L23 23"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const zap: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const zoomIn: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 21L16.65 16.65M11 8V14M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const zoomOut: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M21 21L16.65 16.65M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const userIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0 M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2 M16 3.13a4 4 0 0 1 0 7.75 M21 21v-2a4 4 0 0 0 -3 -3.85"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const trianglePlusIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0v.001z M9 13h6 M12 10v6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const reportAnalyticsIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2 M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z M9 17v-5 M12 17v-1 M15 17v-3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const alertTriangleIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 9v4 M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z M12 16h.01"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const categoryIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d=" M14 4h6v6h-6z M4 14h6v6h-6z M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0 M7 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const listDetailsIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d=" M13 5h8 M13 9h5 M13 15h8 M13 19h5 M3 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z M3 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const adjustmentsHorizontalIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <title>{props.title}</title>
    <path d="M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M4 6l8 0" />
    <path d="M16 6l4 0" />
    <path d="M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M4 12l2 0" />
    <path d="M10 12l10 0" />
    <path d="M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M4 18l11 0" />
    <path d="M19 18l1 0" />
  </svg>
));
export const modulesResponseIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10.4,3.6L2.3,17.1c-.5.9-.2,2.1.7,2.6.3.2.6.3.9.3h16.2c1.1,0,1.9-.9,1.9-1.9,0-.3,0-.6-.3-.9L13.6,3.6c-.5-.9-1.7-1.2-2.6-.6-.3.2-.5.4-.6.6h0Z M11.1,8.1l-4.5,7.5c-.3.5-1,1.6-.7,1.6.8,0,1.4,0,1.6,0h9c.8,0,1.5,0,1.6-.1s-.6-1.3-.7-1.4l-4.5-7.5c-.3-.5-.8-1.4-1-1.3s-.7,1.1-.8,1.3h0Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const modulesHomeIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M5 12l-2 0l9 -9l9 9l-2 0 M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7 M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const settingsIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 9 A3 3 0 1 1 12 15 A3 3 0 1 1 12 9 M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const plusIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 5 L12 19 M5 12 L19 12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const playCircleIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 2 A10 10 0 1 1 12 22 A10 10 0 1 1 12 2 M10 8 L16 12 L10 16 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const layersIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 2 L2 7 L12 12 L22 7 L12 2 Z M2 17 L12 22 L22 17 M2 12 L12 17 L22 12"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const barChartIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 20 L12 10 M18 20 L18 4 M6 20 L6 16" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));
export const alertCircleIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 2 A10 10 0 1 1 12 22 A10 10 0 1 1 12 2 M12 8 L12 12 M12 16 L12.01 16"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export const alertCircleSolid: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g>
      <g id="Layer_1">
        <path
          className="cls-1"
          d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12,12-5.4,12-12S18.6,0,12,0ZM11,6c0-.6.4-1,1-1s1,.4,1,1v7c0,.6-.4,1-1,1s-1-.4-1-1v-7ZM12,18c-.6,0-1-.4-1-1s.4-1,1-1h0c.6,0,1,.4,1,1s-.4,1-1,1Z"
        />
      </g>
    </g>
  </svg>
));

export const checkCircleSolid: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g>
      <g id="Layer_1">
        <path
          className="cls-1"
          d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12,12-5.4,12-12S18.6,0,12,0ZM10.1,17.7c-.2.2-.4.3-.7.3s-.5,0-.7-.3l-4.8-4.8c-.4-.4-.4-1,0-1.4s1-.4,1.4,0l4.1,4.1,8.9-9.1c.4-.4,1-.4,1.4,0s.4,1,0,1.4l-9.6,9.8Z"
        />
      </g>
    </g>
  </svg>
));

export const homeIms: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M3 9 L12 2 L21 9 V20 a2 2 0 0 1-2 2 H5 a2 2 0 0 1-2-2 V9 M9 22 V12 H15 V22"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const carR2C: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0 M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0 M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const carSN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M19.7,4.3c-1.5-.4-3.6-.9-4.3-1.1-.4-.4-1.4-1.4-2.1-2.2-.7-.6-1.5-.9-2.3-.9h-7c-.8,0-1.6.5-2.2,1.4L.4,4.5c-.2.5-.2,1-.2,1.5v4c0,1.1.8,1.8,1.8,1.8h0c0-.3-.1-.5-.1-.8,0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1,0,.6-.1.8h6c0-.3-.1-.5-.1-.8,0-1.7,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2,0,.6-.1.8h0c1.1,0,1.8-.8,1.8-1.8v-3c0-1.2-.9-2.4-2.1-2.7Z"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="5" cy="11" r="2.2" />
    <circle cx="17" cy="11" r="2.2" />
  </svg>
));

export const CarIcon: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-car"
    {...props}
  >
    <title>{props.title}</title>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5" />
  </svg>
));

export const TruckIcon: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-truck"
    {...props}
  >
    <title>{props.title}</title>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5" />
  </svg>
));

export const AmbulanceIcon: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-ambulance"
    {...props}
  >
    <title>{props.title}</title>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5" />
    <path d="M10 9v-2m0 4v-2m-2 0h4" />
  </svg>
));

export const vorR2C: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0 M15.585 15.586a2 2 0 0 0 2.826 2.831 M5 17h-2v-11a1 1 0 0 1 1 -1h1m3.96 0h4.04v4m0 4v4m-4 0h6m6 0v-6h-6m-2 -5h5l3 5 M3 3l18 18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const vorSN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10 1 a9 9 0 1 1 0 18 a9 9 0 1 1 0-18 M4.5 14.3 V6.6 L10 4.2 L15.5 6.6 V14.3 M6.4 14.3 V8.2 H13.6 V14.3 M6.4 10.2 H13.6 M6.4 12.2 H13.6"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const warrantySN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM3.8 16.5V6.8h12.5v9.7M10.4 12.2h4.4M10.4 14.1h4.4M7.7 8.6h-.8l-.7.5-.5.7v.9l.5.7.7.4h.8l.8-.4.4-.7v-.9l-.4-.7-.8-.5zM10.4 10.2h4.4M6.8 11.7v1.3l.5-.4.5.4v-1.3"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const warrantyR2C: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11 M9 7l4 0 M9 11l4 0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const scenarioSN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10 2.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15z"
      strokeWidth="3px"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const scenarioR2C: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 576 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192z"
      strokeWidth="50"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const vehicleTheftSN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM3.6 11.3h6M4.1 9.3h5.8M18.6 6.9h-4.1c-.3 0-.7.2-1 .5l-1.3 1.7c-.1.2-.2.5-.3.7l-.6 2.3c0 .3 0 .6.4.6h1.2M18.8 12.7h-5.8c-.2.6.2 1.2.8 1.2s1.3-.5 1.5-1.2M13 12.7c.2-.6.8-1.2 1.5-1.2s1 .5.8 1.2M15.3 12.7h3.5M4.8 7.4h5.8"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const vehicleTheftR2C: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 12.5l-5-3 5-3 5 3v5.5l-5 3zM11 9.5v5.5l5 3M16 12.545l5-3.03M7 9H2M7 12H4M7 15H6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const vehicle: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 22 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.67"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <title>{props.title}</title>
    <path d="M18 11H20C20.6 11 21 10.6 21 10V7C21 6.1 20.3 5.3 19.5 5.1C17.7 4.6 15 4 15 4C15 4 13.7 2.6 12.8 1.7C12.3 1.3 11.7 1 11 1H4C3.4 1 2.9 1.4 2.6 1.9L1.2 4.8C1.06758 5.18623 1 5.5917 1 6V10C1 10.6 1.4 11 2 11H4M18 11C18 12.1046 17.1046 13 16 13C14.8954 13 14 12.1046 14 11M18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11M4 11C4 12.1046 4.89543 13 6 13C7.10457 13 8 12.1046 8 11M4 11C4 9.89543 4.89543 9 6 9C7.10457 9 8 9.89543 8 11M8 11H14" />
  </svg>
));
export const goodsTheftR2C: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M16 12.5l-5-3 5-3 5 3v5.5l-5 3zM11 9.5v5.5l5 3M16 12.545l5-3.03M7 9H2M7 12H4M7 15H6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const goodsTheftSN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM3.7 12h4M3.1 10h5.1M4.7 8h4M14.8 12.8H9.4l1.4-5.4h5.4l-1.4 5.4zM10.8 7.4l4 5.4"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export const UserPlusWithSteeringWheel: FC<SvgIconConstituentValues> = memo(
  ({ ...props }: SvgIconConstituentValues) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-user-plus-steering-wheel"
      {...props}
    >
      <title>{props.title}</title>
      <circle className="st0" cx="8.4" cy="7.5" r="4.2" />
      <path
        className="st2"
        d="M1.7,21.3h13.3c.4,0,1.2-.2,1.2-1.4v-1.4c0-2.4-1.7-4-3.8-4.5-1.3-.2-1.8.5-3.9.5s-2.5-.9-4.2-.5-3.6,2.1-3.6,4.5,0,.8,0,1.5c0,1.2.6,1.3,1.1,1.3Z"
      />
      <circle className="st0" cx="18.6" cy="16.5" r="4.8" />
      <g>
        <path
          className="st3"
          d="M1.7,21.3h13.3c.4,0,1.2-.2,1.2-1.4v-1.4c0-2.4-1.7-4-3.8-4.5-1.3-.2-1.8.5-3.9.5s-2.5-.9-4.2-.5-3.6,2.1-3.6,4.5,0,.8,0,1.5c0,1.2.6,1.3,1.1,1.3Z"
        />
        <path d="M14.1,20.8H1.8c-.2,0-.6,0-.6-.8v-.7h0v-.8c0-2.1,1.6-3.7,3.2-4,.8-.1,1.2,0,1.8.2.5.2,1.2.4,2.3.4s1.8-.2,2.4-.4c.5-.2.9-.3,1.4-.2.1,0,.2,0,.4.1.1-.3.2-.6.4-.9-.2,0-.4-.1-.6-.2-.8-.1-1.3,0-1.9.2-.5.2-1.1.3-2.1.3s-1.5-.2-2-.3c-.6-.2-1.3-.4-2.3-.2-2,.4-4,2.3-4,5s0,.9,0,1.1v.3c0,1.7,1.1,1.8,1.5,1.8h13.3c0,0,.2,0,.3,0-.4-.3-.8-.6-1.2-1Z" />
      </g>
      <line className="st1" x1="17.8" y1="16.3" x2="14.2" y2="14.5" />
      <line className="st1" x1="19.2" y1="16.3" x2="22.8" y2="14.5" />
      <path className="st1" d="M23.2,16.5" />
      <path className="st1" d="M19.3,16.7" />
      <line className="st1" x1="18.6" y1="17.4" x2="18.6" y2="21.3" />
      <circle className="st0" cx="18.6" cy="16.5" r="1" />
    </svg>
  )
);
export const UserSolid: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    fill="currentColor"
    className="icon icon-tabler icon-user-solid"
    {...props}
  >
    <title>{props.title}</title>
    <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" />
  </svg>
));

export const pin: FC<SvgIconConstituentValues> = memo(({ title, ...props }: SvgIconConstituentValues) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 11 16"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title && <title>{title}</title>}
    <path
      d="M7.07143 2V5.75C7.07143 6.59 7.36214 7.37 7.85714 8H3.14286C3.65357 7.355 3.92857 6.575 3.92857 5.75V2H7.07143ZM9.42857 0.5H1.57143C1.13929 0.5 0.785714 0.8375 0.785714 1.25C0.785714 1.6625 1.13929 2 1.57143 2H2.35714V5.75C2.35714 6.995 1.30429 8 0 8V9.5H4.69071V14.75L5.47643 15.5L6.26214 14.75V9.5H11V8C9.69571 8 8.64286 6.995 8.64286 5.75V2H9.42857C9.86071 2 10.2143 1.6625 10.2143 1.25C10.2143 0.8375 9.86071 0.5 9.42857 0.5Z"
      strokeWidth={0}
    />
  </svg>
));

export const unpin: FC<SvgIconConstituentValues> = memo(({ title, ...props }: SvgIconConstituentValues) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 15"
    fill="none"
    stroke="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    {title && <title>{title}</title>}
    <path
      d="M10.0714 1.5V5.25C10.0714 6.09 10.3621 6.87 10.8571 7.5H6.14286C6.65357 6.855 6.92857 6.075 6.92857 5.25V1.5H10.0714ZM12.4286 0H4.57143C4.13929 0 3.78571 0.3375 3.78571 0.75C3.78571 1.1625 4.13929 1.5 4.57143 1.5H5.35714V5.25C5.35714 6.495 4.30429 7.5 3 7.5V9H7.69071V14.25L8.47643 15L9.26214 14.25V9H14V7.5C12.6957 7.5 11.6429 6.495 11.6429 5.25V1.5H12.4286C12.8607 1.5 13.2143 1.1625 13.2143 0.75C13.2143 0.3375 12.8607 0 12.4286 0Z"
      strokeWidth={0}
    />
    <line x1="0.617822" y1="2.21368" x2="14.6178" y2="13.2137" strokeWidth={1} />
  </svg>
));

export const otherScenario: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.7998 4.7998L9.2998 9.2998M4.7998 4.7998H1.7998L0.799805 1.7998L1.7998 0.799805L4.7998 1.7998V4.7998ZM18.0588 1.54082L15.4312 4.16843C15.0352 4.56445 14.8371 4.76246 14.763 4.99079C14.6977 5.19163 14.6977 5.40798 14.763 5.60882C14.8371 5.83715 15.0352 6.03516 15.4312 6.43117L15.6684 6.66843C16.0645 7.06445 16.2625 7.26246 16.4908 7.33665C16.6916 7.40191 16.908 7.40191 17.1088 7.33665C17.3372 7.26246 17.5352 7.06445 17.9312 6.66843L20.3891 4.21052C20.6538 4.85469 20.7998 5.5602 20.7998 6.2998C20.7998 9.33737 18.3374 11.7998 15.2998 11.7998C14.9336 11.7998 14.5757 11.764 14.2296 11.6957C13.7434 11.5999 13.5003 11.5519 13.353 11.5666C13.1963 11.5822 13.1191 11.6057 12.9803 11.68C12.8497 11.7499 12.7188 11.8808 12.4568 12.1428L5.2998 19.2998C4.47138 20.1282 3.12823 20.1282 2.29981 19.2998C1.47138 18.4714 1.47138 17.1282 2.29981 16.2998L9.45683 9.14277C9.71878 8.88083 9.84975 8.74986 9.91962 8.61929C9.9939 8.48048 10.0174 8.40327 10.033 8.24662C10.0477 8.09926 9.99975 7.85619 9.90387 7.37004C9.8356 7.02386 9.7998 6.66601 9.7998 6.2998C9.7998 3.26224 12.2622 0.799805 15.2998 0.799805C16.3053 0.799805 17.2478 1.06963 18.0588 1.54082ZM10.7999 13.7997L16.2998 19.2997C17.1282 20.1281 18.4714 20.1281 19.2998 19.2997C20.1282 18.4713 20.1282 17.1281 19.2998 16.2997L14.7751 11.7751C14.4548 11.7448 14.1425 11.687 13.8406 11.6041C13.4515 11.4973 13.0247 11.5749 12.7395 11.8601L10.7999 13.7997Z"
      stroke={props.stroke ?? "currentColor"}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
